import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardTitle, Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Select from "react-select";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import { DefaultSettingServices } from "../../services/DefaultSettingServices";
import { signupservices } from "../../services/signupservices";
import * as BullCache from "../../util/BullCache";
import { customStyles, modelDropdown, the } from "../components/customStyles";
import "../custom.css";
import { isMobile } from "../../util/GeneralUtil";
import { NumberToWordFormatter } from "../components/NumberToWordFormatter";
import { NewAccountService } from "../../services/NewAccountService";
import { Percent } from "react-bootstrap-icons";
import { QuantitySettingsService } from "../../services/QuantitySettingsService";

function NewAccount() {
  const [isLoading, setIsLoading] = useState(false);
  var adminId = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache("allScripts");

  const [isCheckedGlobal, setIsCheckedGlobal] = useState(false);
  const [isCheckedNSE, setIsCheckedNSE] = useState(false);
  const [isCheckedMCX, setIsCheckedMCX] = useState(false);
  const [isCheckedNCDEX, setIsCheckedNCDEX] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalMCX, setShowModalMCX] = useState(false);
  const [showModalNSE, setShowModalNSE] = useState(false);
  const [showModalNCDEX, setShowModalNCDEX] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionMCX, setSelectedOptionMCX] = useState(null);
  const [selectedOptionNSE, setSelectedOptionNSE] = useState(null);
  const [
    copySettingNSEForBrokerageDetails,
    setCopySettingNSEForBrokerageDetails,
  ] = useState(null);
  const [copySettingNSEForMarginDetails, setCopySettingNSEForMarginDetails] =
    useState(null);
  const [copySettingNSEForOtherDetails, setCopySettingNSEForOtherDetails] =
    useState(null);
  const [copySettingNSEForQuantitySettings,
    setCopySettingNSEForQuantitySettings] = useState(null);  

  const [
    copySettingMCXForBrokerageDetails,
    setCopySettingMCXForBrokerageDetails,
  ] = useState(null);
  const [copySettingMCXForMarginDetails, setCopySettingMCXForMarginDetails] =
    useState(null);
  const [copySettingMCXForOtherDetails, setCopySettingMCXForOtherDetails] =
    useState(null);
  const [copySettingMCXForQuantitySettings,
    setCopySettingMCXForQuantitySettings] = useState(null);
  

  const [
    copySettingINDEXForBrokerageDetails,
    setCopySettingINDEXForBrokerageDetails,
  ] = useState(null);
  const [
    copySettingINDEXForMarginDetails,
    setCopySettingINDEXForMarginDetails,
  ] = useState(null);
  const [copySettingINDEXForOtherDetails, setCopySettingINDEXForOtherDetails] =
    useState(null);

  const [
    copySettingNCDEXForBrokerageDetails,
    setCopySettingNCDEXForBrokerageDetails,
  ] = useState(null);
  const [
    copySettingNCDEXForMarginDetails,
    setCopySettingNCDEXForMarginDetails,
  ] = useState(null);
  const [copySettingNCDEXForOtherDetails, setCopySettingNCDEXForOtherDetails] =
    useState(null);
  const [copySettingGLOBALForQuantitySettings,
    setCopySettingGLOBALForQuantitySettings] = useState(null);

  // const [selectedOptionNSE, setSelectedOptionNSE] = useState(null);
  // const [selectedOptionNSE, setSelectedOptionNSE] = useState(null);
  const [selectedOptionNCDEX, setSelectedOptionNCDEX] = useState(null);
  const [copySettingOptions, setCopySettingOptions] = useState([]);
  const [inputFields, setInputFields] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [
    inputFieldsMCXRatherThanCustomerType,
    setInputFieldsMCXRatherThanCustomerType,
  ] = useState([]);
  const [
    inputFieldsNSERatherThanCustomerType,
    setInputFieldsNSERatherThanCustomerType,
  ] = useState([]);
  const [
    inputFieldsNCDEXRatherThanCustomerType,
    setInputFieldsNCDEXRatherThanCustomerType,
  ] = useState([]);
  const [inputFieldsForINDEXBroker1, setInputFieldsINDEXForBroker1] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForINDEXBroker2, setInputFieldsINDEXForBroker2] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForNSEBroker1, setInputFieldsForNSEBroker1] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForNSEBroker2, setInputFieldsForNSEBroker2] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForMCXBroker1, setInputFieldsForMCXBroker1] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForMCXBroker2, setInputFieldsForMCXBroker2] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForNCDEXBroker1, setInputFieldsForNCDEXBroker1] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForNCDEXBroker2, setInputFieldsForNCDEXBroker2] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsNSE, setInputFieldsNSE] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsMCX, setInputFieldsMCX] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsNCDEX, setInputFieldsNCDEX] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);

  const [quantitysettingsNSE, setQuantitysettingsNSE] = useState([
    { id: 1, segment: "NSE", script:"ALL", type:"QTY", minOrder: null, maxOrder: null, positionLimit: null },
  ]);
  const [quantitysettingsMCX, setQuantitysettingsMCX] = useState([
    { id: 1, segment: "MCX", script:"ALL", type:"LOT", minOrder: null, maxOrder: null, positionLimit: null },
  ]);
  const [quantitysettingsGLOBAL, setQuantitysettingsGLOBAL] = useState([
    { id: 1, segment: "GLOBAL", script:"ALL", type:"QTY", minOrder: null, maxOrder: null, positionLimit: null },
  ]);

  const adminChange2 = (e) => {
    setSelectedRole(e.target.value);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === "index") {
      setIsCheckedGlobal(checked);
    } else if (name === "nse") {
      setIsCheckedNSE(checked);
    } else if (name === "mcx") {
      setIsCheckedMCX(checked);
    } else if (name === "ncdex") {
      setIsCheckedNCDEX(checked);
    }
  };
  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleOpenModalMCX = () => {
    setShowModalMCX(true);
  };

  const handleCloseModalMCX = () => {
    setShowModalMCX(false);
  };
  const handleOpenModalNSE = () => {
    setShowModalNSE(true);
  };

  const handleCloseModalNSE = () => {
    setShowModalNSE(false);
  };
  const handleOpenModalNCDEX = () => {
    setShowModalNCDEX(true);
  };

  const handleCloseModalNCDEX = () => {
    setShowModalNCDEX(false);
  };

  const [customer, setCustomer] = useState([]);
  const [master, setMaster] = useState([]);
  const [broker, setBroker] = useState([]);

  //GLOBAL
  //Brokerage Details
  const [radioSelection, setRadioSelection] = useState("PERCENT");
  const [brokerageScripts, setBrokerageScripts] = useState([]);
  const [minPerBrokeragePerClientINDEX, setMinPerBrokeragePerClientINDEX] =
    useState();
  //Margin Details
  const [marginDetailsRadioSelection, setMarginDetailsRadioSelection] =
    useState("AMOUNT");
  const [marginDetailsINDEXLot, setMarginDetailsINEDXLot] = useState();
  const [marginDetailsINDEXAmount, setMarginDetailsINDEXAmount] = useState();
  const [marginDetailsDelivery, setMarginDetailsDelivery] = useState(0);
  const [marginDetails, setMarginDetails] = useState(0);
  const [maxMarginPerClientINDEX, setMaxMarginPerClientINDEX] = useState();
  //Script Details
  const [scriptDetailsRadioSelection, setScriptDetailsRadioSelection] =
    useState("ALLOW");
  const [
    scriptDetailsIndexRadioSelection,
    setScriptDetailsIndexRadioSelection,
  ] = useState("ALLOW");
  const [scriptDetailsScriptINDEX, setScriptDetailsScriptINDEX] = useState([]);
  const [blockedScriptDetailsINDEX, setBlockedScriptDetailsINDEX] = useState(
    []
  );
  const [allowedScriptsINDEX, setAllowedScriptsINDEX] = useState([]);
  const [blockedScriptsINDEX, setBlockedScriptsINDEX] = useState([]);

  //MCX
  //Brokerage Details
  const [radioSelectionMCX, setRadioSelectionMCX] = useState("LOT");
  const [brokerageScriptsMCX, setBrokerageScriptsMCX] = useState([]);
  const [minPerBrokeragePerClientMCX, setMinPerBrokeragePerClientMCX] =
    useState();
  const [minLotBrokeragePerClientMCX, setMinLotBrokeragePerClientMCX] =
    useState();
  //Margin Details
  const [marginDetailsRadioSelectionMCX, setMarginDetailsRadioSelectionMCX] =
    useState("LOT");
  const [marginDetailsDeliveryMCX, setMarginDetailsDeliveryMCX] = useState(0);
  const [marginDetailsMCX, setMarginDetailsMCX] = useState(0);
  const [marginDetailsMCXLot, setMarginDetailsMCXLot] = useState();
  const [marginDetailsMCXAmount, setMarginDetailsMCXAmount] = useState();
  const [maxMarginPerClientMCX, setMaxMarginPerClientMCX] = useState();
  const [maxLotPerClientMCX, setMaxLotPerClientMCX] = useState();
  //Script Details
  const [scriptDetailsRadioSelectionMCX, setScriptDetailsRadioSelectionMCX] =
    useState("ALLOW");
  const [scriptDetailsScriptMCX, setScriptDetailsScriptMCX] = useState([]);
  const [blockedScriptDetailsMCX, setBlockedScriptDetailsMCX] = useState([]);
  const [allowedScriptsMCX, setAllowedScriptsMCX] = useState([]);
  const [blockedScriptsMCX, setBlockedScriptsMCX] = useState([]);

  //NSE
  //Brokerage Details
  const [radioSelectionNSE, setRadioSelectionNSE] = useState("PERCENT");
  const [brokerageScriptsNSE, setBrokerageScriptsNSE] = useState([]);
  const [brokerageDropdownNSE, setBrokerageDropdownNSE] = useState([]);
  const [minPerBrokeragePerClientNSE, setMinPerBrokeragePerClientNSE] =
    useState();
  //Margin Details
  const [marginDetailsRadioSelectionNSE, setMarginDetailsRadioSelectionNSE] =
    useState("AMOUNT");
  const [marginDetailsDeliveryNSE, setMarginDetailsDeliveryNSE] = useState(0);
  const [marginDetailsNSELot, setMarginDetailsNSELot] = useState();
  const [marginDetailsNSEAmount, setMarginDetailsNSEAmount] = useState();
  const [maxMarginPerClientNSE, setMaxMarginPerClientNSE] = useState();
  //Script Details
  const [scriptDetailsRadioSelectionNSE, setScriptDetailsRadioSelectionNSE] =
    useState("ALLOW");
  const [scriptDetailsScriptNSE, setScriptDetailsScriptNSE] = useState([]);
  const [blockedScriptDetailsNSE, setBlockedScriptDetailsNSE] = useState([]);
  const [allowedScriptsNSE, setAllowedScriptsNSE] = useState([]);
  const [blockedScriptsNSE, setBlockedScriptsNSE] = useState([]);

  //NCDEX
  //Brokerage Details
  const [radioSelectionNCDEX, setRadioSelectionNCDEX] = useState("LOT");
  const [brokerageScriptsNCDEX, setBrokerageScriptsNCDEX] = useState([]);
  const [brokerageDropdownNCDEX, setBrokerageDropdownNCDEX] = useState([]);
  const [minPerBrokeragePerClientNCDEX, setMinPerBrokeragePerClientNCDEX] =
    useState();
  const [minLotBrokeragePerClientNCDEX, setMinLotBrokeragePerClientNCDEX] =
    useState();
  //Margin Details
  const [
    marginDetailsRadioSelectionNCDEX,
    setMarginDetailsRadioSelectionNCDEX,
  ] = useState("LOT");

  const [marginDetailsNCDEXLot, setMarginDetailsNCDEXLot] = useState();
  const [marginDetailsNCDEXAmount, setMarginDetailsNCDEXAmount] = useState();
  const [marginDetailsDeliveryNCDEX, setMarginDetailsDeliveryNCDEX] =
    useState(0);
  const [marginDetailsNCDEX, setMarginDetailsNCDEX] = useState(0);
  const [maxMarginPerClientNCDEX, setMaxMarginPerClientNCDEX] = useState();
  //Script Details
  const [
    scriptDetailsRadioSelectionNCDEX,
    setScriptDetailsRadioSelectionNCDEX,
  ] = useState("ALLOW");
  const [scriptDetailsScriptNCDEX, setScriptDetailsScriptNCDEX] = useState([]);
  const [blockedScriptDetailsNCDEX, setBlockedScriptDetailsNCDEX] = useState(
    []
  );
  const [allowedScriptsNCDEX, setAllowedScriptsNCDEX] = useState([]);
  const [blockedScriptsNCDEX, setBlockedScriptsNCDEX] = useState([]);

  const [subBroker, setSubBroker] = useState([]);
  const [selectBroker1Partner, setSelectBroker1Partner] = useState("");
  const [selectBroker2Partner, setSelectBroker2Partner] = useState("");
  const [orderHighLow, setOrderHighLow] = useState(false);
  const [applyAutoSquare, setAutoSquare] = useState(false);
  const [tradeAllowed, setTradeAllowed] = useState(true);
  const [intraDayAutoSquare, setIntraDayAutoSquare] = useState(false);
  const [onlyPositionSquareOff, setOnlyPositionSquare] = useState(false);
  const [rollOver, setRollOver] = useState(true);
  const [onlyViewAccess, setOnlyViewAccess] = useState(false);
  const [m2mLinkWithLedger, setm2mLinkWithLedger] = useState(false);
  const [bandScriptAllow, setBandScriptAllow] = useState(false);
  const [ledgerView, setLedgerView] = useState(true);
  const [selectedBroker1, setSelectedBroker1] = useState("");
  const [selectedBroker2, setSelectedBroker2] = useState("");

  const [scriptDeatailsDropdown, setScriptDeatailsDropdown] = useState([]);
  const [scriptDeatailsDropdownIndex, setScriptDeatailsDropdownIndex] =
    useState([]);
  const [scriptDetailsScript, setScriptDetailsScript] = useState([]);
  const [blockedScriptDropdown, setBlockedScriptDropdown] = useState([]);
  const [blockedScriptDropdownIndex, setBlockedScriptDropdownIndex] = useState(
    []
  );
  const [blockedScriptDetails, setBlockedScriptDetails] = useState([]);

  const [scriptDeatailsDropdownMCX, setScriptDeatailsDropdownMCX] = useState(
    []
  );
  // const [scriptDetailsScriptMCX, setScriptDetailsScriptMCX] = useState([]);
  const [blockedScriptDropdownMCX, setBlockedScriptDropdownMCX] = useState([]);
  // const [blockedScriptDetailsMCX, setBlockedScriptDetailsMCX] = useState([]);

  const [scriptDeatailsDropdownNSE, setScriptDeatailsDropdownNSE] = useState(
    []
  );
  const [mcxScriptToWork, setMCXScriptToWork] = useState();
  const [indexScriptToWork, setIndexScriptToWork] = useState();
  const [NseScriptToWork, setNSEScriptToWork] = useState();
  const [ncdexScriptToWork, setNcdexScriptToWork] = useState();
  const [mcxFreshLimitAllowed, setMcxFreshLimitAllowed] = useState(true);
  const [indexFreshLimitAllowed, setIndexFreshLimitAllowed] = useState(true);
  const [nseFreshLimitAllowed, setNseFreshLimitAllowed] = useState(true);
  const [ncdexFreshLimitAllowed, setNcdexFreshLimitAllowed] = useState(true);
  //  const [scriptDetailsScriptNSE, setScriptDetailsScriptNSE] = useState([]);
  const [blockedScriptDropdownNSE, setBlockedScriptDropdownNSE] = useState([]);
  //  const [blockedScriptDetailsNSE, setBlockedScriptDetailsNSE] = useState([]);
  const [scriptDeatailsDropdownNCDEX, setScriptDeatailsDropdownNCDEX] =
    useState([]);
  //  const [scriptDetailsScriptNCDEX, setScriptDetailsScriptNCDEX] = useState([]);
  const [blockedScriptDropdownNCDEX, setBlockedScriptDropdownNCDEX] = useState(
    []
  );
  //  const [blockedScriptDetailsNCDEX, setBlockedScriptDetailsNCDEX] = useState([]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "Abcd1234",
    squareOffDisabledInMin: 2,
    tradeBlockAbove: 100000,
    tradeBlockBelow: 100
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const handleRadioChange = (value) => {
    setLedgerView(value); // Set to 'true' for YES or 'false' for NO
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value.toUpperCase(),
    });
    validateField(name, value);
  };
  const validateField = (name, value) => {
    let errorMessage = "";
    if (name === "firstName" && !value) {
      errorMessage = "* ";
    }
    if (name === "partnership" && !value) {
      errorMessage = "* ";
    }
    if (name === "brokerage" && !value) {
      errorMessage = "* ";
    }
    if (name === "password" && !value) {
      errorMessage = "* ";
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };

  useEffect(() => {
    // setLoading(true);
    NewAccountService.getCopySettings({
      adminId: adminId.adminId,
      accountType: selectedRole,
    }).then((resp) => {
      // setLoading(false);
      if (resp.code === 1) {
        setCopySettingOptions(resp?.data?.copySetting);
      }
    });
  }, [selectedRole]);

  useEffect(() => {
    if (adminId.segments.includes("NSE")) {
      const nseData = [];
      for (const category in allScripts.NSE) {
        nseData.push({ label: category, value: category });
      }
      setBrokerageScriptsNSE(nseData);
      setScriptDetailsScriptNSE(nseData);
      setBlockedScriptDetailsNSE(nseData);
      //setScriptDetailsScriptINDEX(nseData);

      //setScriptDetailsScript(indexData);
    }

    if (adminId.segments.includes("MCX")) {
      const mcxData = [];
      for (const category in allScripts.MCX) {
        mcxData.push({ label: category, value: category });
      }
      setBrokerageScriptsMCX(mcxData);
      setScriptDetailsScriptMCX(mcxData);
      setBlockedScriptDetailsMCX(mcxData);
    }

    if (adminId.segments.includes("GLOBAL")) {
      const globalData = [];
      for (const category in allScripts.GLOBAL) {
        globalData.push({ label: category, value: category });
      }

      setBrokerageScripts(globalData);
      setScriptDetailsScript(globalData);
      setBlockedScriptDetails(globalData);
    }
  }, [selectedRole]);

  useEffect(() => {
    if (adminId.adminType !== "SUBBROKER") {
      signupservices.getSubBrokers({ adminId: adminId.adminId }).then((res) => {
        if (res.code === 1) {
          if (res.data.subbrokerList.length > 0) {
            setSubBroker(res.data.subbrokerList);
          }
        }
      });
    }
    signupservices.getCustomer({ adminId: adminId.adminId }).then((res) => {
      if (res.code === 1) {
        if (res.data.userList.length > 0) {
          setCustomer(res.data.userList);
        }
      }
    });

    if (
      adminId.adminType === "SUPER_ADMIN" ||
      adminId.adminType === "ADMIN" ||
      adminId.adminType === "MASTER" || adminId.adminType == 'SUPER_MASTER'
    ) {
      signupservices.getBrokers({ adminId: adminId.adminId }).then((res) => {
        if (res.code === 1) {
          if (res.data.brokerList.length > 0) {
            setBroker(res.data.brokerList);
          }
        }
      });
    }

    if (adminId.adminType === "SUPER_ADMIN" || adminId.adminType === "ADMIN" || adminId.adminType == 'SUPER_MASTER') {
      signupservices.getMaster({ adminId: adminId.adminId }).then((res) => {
        if (res.code === 1) {
          if (res.data.masterList.length > 0) {
            setMaster(res.data.masterList);
          }
        }
      });
    }
  }, []);

  //NSE - Brokerage Details , Margin Details, Script Details
  useEffect(() => {
    if (copySettingNSEForBrokerageDetails) {
      const brokerageDetails =
        copySettingNSEForBrokerageDetails?.copySettings?.NSE?.brokerageDetails;

      if (brokerageDetails && brokerageDetails.length > 0) {
        setMinPerBrokeragePerClientNSE(brokerageDetails[0].percent);
        setRadioSelectionNSE(brokerageDetails[0].type || "PERCENT");
        const inputFields = brokerageDetails.map((detail, index) => ({
          id: Date.now() + index,
          selectedScript: detail.script || null,
          deliveryCom: detail.deliveryCom || null,
          intradayCom: detail.intradayCom || null,
        }));
        setInputFieldsNSE((prevFields) => [...prevFields, ...inputFields]);
      }
    }
  }, [copySettingNSEForBrokerageDetails]);
  useEffect(() => {
    if (copySettingNSEForMarginDetails) {
      const marginDetails =
        copySettingNSEForMarginDetails?.copySettings?.NSE?.marginDetails;

      if (marginDetails && marginDetails.length > 0) {
        setMaxMarginPerClientNSE(marginDetails[0].maxMarginPerClient);
        if (
          marginDetails[0].amount !== null &&
          marginDetailsRadioSelectionNSE === "AMOUNT"
        ) {
          setMarginDetailsRadioSelectionNSE("AMOUNT");
          setMarginDetailsNSEAmount(marginDetails[0].amount);
        } else if (
          marginDetails[0].lot !== null &&
          marginDetailsRadioSelectionNSE === "LOT"
        ) {
          setMarginDetailsRadioSelectionNSE("LOT");
          setMarginDetailsNSELot(marginDetails[0].lot);
        } 
      }
    }
  }, [copySettingNSEForMarginDetails, marginDetailsRadioSelectionNSE]);

  useEffect(() => {
    if (copySettingNSEForOtherDetails) {
      if (copySettingNSEForOtherDetails) {
        const otherDetails =
          copySettingNSEForOtherDetails?.copySettings?.NSE?.otherDetails;
        if (otherDetails) {
          setNSEScriptToWork(otherDetails?.scriptToWork);
          setNseFreshLimitAllowed(otherDetails?.freshLimit);
          if (
            otherDetails?.allowedScripts &&
            otherDetails?.allowedScripts?.length > 0
          ) {
            setScriptDetailsRadioSelectionNSE("ALLOW");
            setScriptDeatailsDropdownNSE(
              otherDetails?.allowedScripts
                ? otherDetails?.allowedScripts.map((option) => option)
                : []
            );
          }
          if (
            otherDetails?.blockedScripts &&
            otherDetails?.blockedScripts?.length > 0
          ) {
            setScriptDetailsRadioSelectionNSE("BLOCK");
            setBlockedScriptDropdownNSE(
              otherDetails?.blockedScripts
                ? otherDetails?.blockedScripts.map((option) => option)
                : []
            );
          }
        }
      }
    }
  }, [copySettingNSEForOtherDetails]);

  //

  // GLOBAL - Brokerage Details , Margin Details, Script Details
  useEffect(() => {
    if (copySettingINDEXForBrokerageDetails) {
      const brokerageDetails =
        copySettingINDEXForBrokerageDetails?.copySettings?.GLOBAL
          ?.brokerageDetails;

      if (brokerageDetails && brokerageDetails.length > 0) {
        setMinPerBrokeragePerClientINDEX(brokerageDetails[0].percent);
        setRadioSelection(brokerageDetails[0].type || "PERCENT");

        const inputFields = brokerageDetails.map((detail, index) => ({
          id: Date.now() + index,
          selectedScript: detail.script || null,
          deliveryCom: detail.deliveryCom || null,
          intradayCom: detail.intradayCom || null,
        }));
        setInputFields((prevFields) => [...prevFields, ...inputFields]);
      }
    }
  }, [copySettingINDEXForBrokerageDetails]);

  useEffect(() => {
    if (copySettingINDEXForMarginDetails) {
      const marginDetails =
        copySettingINDEXForMarginDetails?.copySettings?.GLOBAL?.marginDetails;

      if (marginDetails && marginDetails.length > 0) {
        setMaxMarginPerClientINDEX(marginDetails[0].maxMarginPerClient);
        if (
          marginDetails[0].amount !== null &&
          marginDetailsRadioSelection === "AMOUNT"
        ) {
          setMarginDetailsRadioSelection("AMOUNT");
          setMarginDetailsINDEXAmount(marginDetails[0].amount);
          // setMarginDetailsDelivery(marginDetails[0].amount );
          // setMarginDetails({ lot: null, amount: marginDetails[0].amount });
        } else if (
          marginDetails[0].lot !== null &&
          marginDetailsRadioSelection === "LOT"
        ) {
          setMarginDetailsRadioSelection("LOT");
          setMarginDetailsINEDXLot(marginDetails[0].lot);
          // setMarginDetailsDelivery(marginDetails[0].lot);
          // setMarginDetails({ lot: marginDetails[0].lot, amount:null  });
        } else {
          setMarginDetails({ lot: null, amount: null });
        }
      }
    }
  }, [copySettingINDEXForMarginDetails, marginDetailsRadioSelection]);

  useEffect(() => {
    if (copySettingINDEXForOtherDetails) {
      const otherDetails =
        copySettingINDEXForOtherDetails?.copySettings?.GLOBAL?.otherDetails;
      if (otherDetails) {
        setIndexScriptToWork(otherDetails?.scriptToWork);
        setIndexFreshLimitAllowed(otherDetails?.freshLimit);
        if (
          otherDetails?.allowedScripts &&
          otherDetails?.allowedScripts?.length > 0
        ) {
          setScriptDetailsIndexRadioSelection("ALLOW");
          setScriptDeatailsDropdownIndex(
            otherDetails?.allowedScripts
              ? otherDetails?.allowedScripts.map((option) => option)
              : []
          );
        }
        if (
          otherDetails?.blockedScripts &&
          otherDetails?.blockedScripts?.length > 0
        ) {
          setScriptDetailsIndexRadioSelection("BLOCK");
          setBlockedScriptDropdownIndex(
            otherDetails?.blockedScripts
              ? otherDetails?.blockedScripts.map((option) => option)
              : []
          );
        }
      }
    }
  }, [copySettingINDEXForOtherDetails]);
  //

  //MCX - Brokerage Details , Margin Details, Script Details
  useEffect(() => {
    if (copySettingMCXForBrokerageDetails) {
      const brokerageDetails =
        copySettingMCXForBrokerageDetails?.copySettings?.MCX?.brokerageDetails;

      if (brokerageDetails && brokerageDetails.length > 0) {
        setRadioSelectionMCX(brokerageDetails[0].type || "PERCENT");
        setMinPerBrokeragePerClientMCX(brokerageDetails[0]?.percent);
        setMinLotBrokeragePerClientMCX(brokerageDetails[0]?.lot);
        const updatedFields = brokerageDetails
          ?.slice(1) // Skip the first element (index 0)
          .map((item) => ({
            id: uuidv4(),
            selectedScript: item?.script,
            mcxPercentage: item?.percent,
            mcxLot: item?.lot,
          }));
        setInputFieldsMCXRatherThanCustomerType(updatedFields);
        const inputFields = brokerageDetails.map((detail, index) => ({
          id: Date.now() + index,
          selectedScript: detail.script || null,
          deliveryCom: detail.deliveryCom || null,
          intradayCom: detail.intradayCom || null,
        }));
        setInputFieldsMCX((prevFields) => [...prevFields, ...inputFields]);
      }
    }
  }, [copySettingMCXForBrokerageDetails]);
  useEffect(() => {
    if (copySettingMCXForMarginDetails) {
      const marginDetails =
        copySettingMCXForMarginDetails?.copySettings?.MCX?.marginDetails;

      if (marginDetails && marginDetails.length > 0) {
        setMaxMarginPerClientMCX(marginDetails[0].maxMarginPerClient);
        setMaxLotPerClientMCX(marginDetails[0].maxLotPerClient);
        if (
          marginDetails[0].amount !== null &&
          marginDetailsRadioSelectionMCX === "AMOUNT"
        ) {
          setMarginDetailsRadioSelectionMCX("AMOUNT");
          setMarginDetailsMCXAmount(marginDetails[0].amount);
          // setMarginDetailsDeliveryMCX(marginDetails[0].amount );
          // setMarginDetailsMCX({ lot: null, amount: marginDetails[0].amount });
        } else if (
          marginDetails[0].lot !== null &&
          marginDetailsRadioSelectionMCX === "LOT"
        ) {
          setMarginDetailsRadioSelectionMCX("LOT");
          setMarginDetailsMCXLot(marginDetails[0].lot);
          // setMarginDetailsDeliveryMCX(marginDetails[0].lot);
          // setMarginDetailsMCX({ lot: marginDetails[0].lot, amount:null  });
        } else {
          setMarginDetailsMCX({ lot: null, amount: null });
        }
      }
    }
  }, [copySettingMCXForMarginDetails, marginDetailsRadioSelectionMCX]);
  useEffect(() => {
    if (copySettingMCXForOtherDetails) {
      const otherDetails =
        copySettingMCXForOtherDetails?.copySettings?.MCX?.otherDetails;
      if (otherDetails) {
        setMCXScriptToWork(otherDetails?.scriptToWork);
        setMcxFreshLimitAllowed(otherDetails?.freshLimit);
        if (
          otherDetails?.allowedScripts &&
          otherDetails?.allowedScripts?.length > 0
        ) {
          setScriptDetailsRadioSelection("ALLOW");
          setScriptDeatailsDropdownMCX(
            otherDetails?.allowedScripts
              ? otherDetails?.allowedScripts.map((option) => option)
              : []
          );
        }
        if (
          otherDetails?.blockedScripts &&
          otherDetails?.blockedScripts?.length > 0
        ) {
          setScriptDetailsRadioSelection("BLOCK");
          setBlockedScriptDropdownMCX(
            otherDetails?.blockedScripts
              ? otherDetails?.blockedScripts.map((option) => option)
              : []
          );
        }
      }
    }
  }, [copySettingMCXForOtherDetails]);
  //

  //NCDEX - Brokerage Details , Margin Details, Script Details
  useEffect(() => {
    const brokerageDetails =
      copySettingNCDEXForBrokerageDetails?.copySettings?.NCDEX
        ?.brokerageDetails;

    if (brokerageDetails && brokerageDetails.length > 0) {
      setRadioSelectionNCDEX(brokerageDetails[0].type || "PERCENT");

      const inputFields = brokerageDetails.map((detail, index) => ({
        id: Date.now() + index,
        selectedScript: detail.script || null,
        deliveryCom: detail.deliveryCom || null,
        intradayCom: detail.intradayCom || null,
      }));
      setInputFieldsNCDEX((prevFields) => [...prevFields, ...inputFields]);
    }
  }, [copySettingNCDEXForBrokerageDetails]);
  useEffect(() => {
    const marginDetails =
      copySettingNCDEXForMarginDetails?.copySettings?.NCDEX?.marginDetails;

    if (marginDetails && marginDetails.length > 0) {
      if (
        marginDetails[0].amount !== null &&
        marginDetailsRadioSelectionNCDEX === "AMOUNT"
      ) {
        setMarginDetailsRadioSelectionNCDEX("AMOUNT");
        setMarginDetailsNCDEXAmount(marginDetails[0].amount);
        // setMarginDetailsDeliveryNCDEX(marginDetails[0].amount );
        // setMarginDetailsMCX({ lot: null, amount: marginDetails[0].amount });
      } else if (
        marginDetails[0].lot !== null &&
        marginDetailsRadioSelectionNCDEX === "LOT"
      ) {
        setMarginDetailsRadioSelectionMCX("LOT");
        setMarginDetailsNCDEXLot(marginDetails[0].lot);
        // setMarginDetailsDeliveryNCDEX(marginDetails[0].lot);
        // setMarginDetailsNCDEX({ lot: marginDetails[0].lot, amount:null  });
      } else {
        setMarginDetailsNCDEX({ lot: null, amount: null });
      }
    }
  }, [copySettingNCDEXForMarginDetails, marginDetailsRadioSelectionNCDEX]);

  useEffect(() => {
    if (copySettingNCDEXForOtherDetails) {
      if (copySettingNCDEXForOtherDetails) {
        const otherDetails =
          copySettingNSEForOtherDetails?.copySettings?.NCDEX?.otherDetails;
        if (otherDetails) {
          setNcdexScriptToWork(otherDetails?.scriptToWork);
          setNcdexFreshLimitAllowed(otherDetails?.freshLimit);
          if (
            otherDetails?.allowedScripts &&
            otherDetails?.allowedScripts?.length > 0
          ) {
            setScriptDetailsRadioSelectionNCDEX("ALLOW");
            setScriptDeatailsDropdownNCDEX(
              otherDetails?.allowedScripts
                ? otherDetails?.allowedScripts.map((option) => option)
                : []
            );
          }
          if (
            otherDetails?.blockedScripts &&
            otherDetails?.blockedScripts?.length > 0
          ) {
            setScriptDetailsRadioSelectionNCDEX("BLOCK");
            setBlockedScriptDropdownNCDEX(
              otherDetails?.blockedScripts
                ? otherDetails?.blockedScripts.map((option) => option)
                : []
            );
          }
        }
      }
    }
  }, [copySettingNCDEXForOtherDetails]);
  //

  const options =
    selectedRole === "CUSTOMER"
      ? customer.map((customer) => ({
          value: customer.id,
          label: `${customer.firstName} (${customer.userName})`,
        }))
      : selectedRole === "MASTER"
      ? master.map((master) => ({
          value: master.id,
          label: `${master.firstName} (${master.userName})`,
        }))
      : selectedRole === "BROKER"
      ? broker.map((broker) => ({
          value: broker.id,
          label: `${broker.firstName} (${broker.userName})`,
        }))
      : selectedRole === "SUBBROKER"
      ? subBroker.map((subBroker) => ({
          value: subBroker.id,
          label: `${subBroker.firstName} (${subBroker.userName})`,
        }))
      : null;

  const doNewAccount = (e) => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    e.preventDefault();
    const formData = new FormData(e.target);
    const formObject = Object.fromEntries(formData.entries());

    let brokerageDetailsIndex = [];
    if (formObject.adminType === "CUSTOMER") {
      inputFields.forEach((field) => {
        if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
          brokerageDetailsIndex.push({
            script: field.selectedScript,
            deliveryCom: parseFloat(field.deliveryCom) || 0,
            intradayCom: parseFloat(field.intradayCom) || 0,
            type: radioSelection,
            minPerBrokeragePerClient: minPerBrokeragePerClientINDEX,
          });
        }
      });
    } else {
      inputFields.forEach((field) => {
        if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
          brokerageDetailsIndex.push({
            script: "ALL",
            percent: minPerBrokeragePerClientINDEX || 0,
            lot: null,
          });
        }
      });
    }
    let broker1NSEData = [];
    inputFieldsForNSEBroker1.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        broker1NSEData.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
          type: radioSelectionNSE,
        });
      }
    });
    let broker2NSEData = [];
    inputFieldsForNSEBroker2.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        broker2NSEData.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
          type: radioSelectionNSE,
        });
      }
    });
    let broker1MCXData = [];
    inputFieldsForMCXBroker1.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        broker1MCXData.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
          type: radioSelectionMCX,
        });
      }
    });
    let broker2MCXData = [];
    inputFieldsForMCXBroker2.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        broker2MCXData.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
          type: radioSelectionMCX,
        });
      }
    });
    let broker1NCDEXData = [];
    inputFieldsForNCDEXBroker1.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        broker1NCDEXData.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
          type: radioSelectionNCDEX,
        });
      }
    });
    let broker2NCDEXData = [];
    inputFieldsForNCDEXBroker2.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        broker2NCDEXData.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
          type: radioSelectionNCDEX,
        });
      }
    });
    let broker1INDEXData = [];
    inputFieldsForINDEXBroker1.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        broker1INDEXData.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
          type: radioSelection,
        });
      }
    });
    let broker2INDEXData = [];
    inputFieldsForINDEXBroker2.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        broker2INDEXData.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
          type: radioSelection,
        });
      }
    });

    let brokerageDetailsNSE = [];
    if (formObject.adminType === "CUSTOMER") {
      inputFieldsNSE.forEach((field) => {
        if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
          brokerageDetailsNSE.push({
            script: field.selectedScript,
            deliveryCom: parseFloat(field.deliveryCom) || 0,
            intradayCom: parseFloat(field.intradayCom) || 0,
            type: radioSelectionNSE,
            minPerBrokeragePerClient: minPerBrokeragePerClientNSE,
          });
        }
      });
    } else {
      inputFieldsNSE.forEach((field) => {
        if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
          brokerageDetailsNSE.push({
            script: "ALL",
            percent: minPerBrokeragePerClientNSE || 0,
            lot: null,
          });
        }
      });
    }

    let brokerageDetailsMCX = [];
    inputFieldsMCX.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        brokerageDetailsMCX.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
          type: radioSelectionMCX,
          minPerBrokeragePerClient: minPerBrokeragePerClientMCX,
          minLotBrokeragePerClient: minLotBrokeragePerClientMCX,
        });
      }
    });

    let brokerageDetailsMCXRatherThanCustomerType = [];
    if (formObject.adminType !== "CUSTOMER") {
      const customMCXObjectForRatherThanCustomerType = {
        script: "ALL",
        percent: minPerBrokeragePerClientMCX,
        lot: minLotBrokeragePerClientMCX,
      };
      brokerageDetailsMCXRatherThanCustomerType.push(
        customMCXObjectForRatherThanCustomerType
      );
    }
    inputFieldsMCXRatherThanCustomerType.forEach((field) => {
      if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
        brokerageDetailsMCXRatherThanCustomerType.push({
          script: field.selectedScript,
          percent: parseFloat(field.mcxPercentage) || 0,
          lot: parseFloat(field.mcxLot) || 0,
        });
      }
    });
    let brokerageDetailsNCDEX = [];
    if (formObject.adminType === "CUSTOMER") {
      inputFieldsNCDEX.forEach((field) => {
        if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
          brokerageDetailsNCDEX.push({
            script: field.selectedScript,
            deliveryCom: parseFloat(field.deliveryCom) || 0,
            intradayCom: parseFloat(field.intradayCom) || 0,
            type: radioSelectionNCDEX,
            minPerBrokeragePerClient: minPerBrokeragePerClientNCDEX,
            minLotBrokeragePerClient: minLotBrokeragePerClientNCDEX,
          });
        }
      });
    } else {
      inputFieldsNCDEX.forEach((field) => {
        if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
          brokerageDetailsNCDEX.push({
            script: "ALL",
            percent: minPerBrokeragePerClientNCDEX || 0,
            lot: minLotBrokeragePerClientNCDEX || 0,
          });
        }
      });
    }

    let accountDetails = {
      partnership: parseInt(formObject.partnership, 10),
      orderHighLow: orderHighLow || formObject.orderHighLow || "false",
      applyAutoSquare: applyAutoSquare || formObject.applyAutoSquare || "false",
      intradaySquare:
        intraDayAutoSquare || formObject.intraDayAutoSquare || "false",
      onlyPositionSquareOff:
        onlyPositionSquareOff || formObject.onlyPositionSquareOff || "false",
      rollOver: rollOver || formObject.rollOver || "false",
      onlyViewAccess: onlyViewAccess || formObject.onlyViewAccess || "false",
      m2mLinkedWithLedger:
        m2mLinkWithLedger || formObject.m2mLinkedWithLedger || "false",
      bandScriptAllow: bandScriptAllow || formObject.bandScriptAllow || "false",
      squareOffDisabledInMin: formObject.squareOffDisabledInMin || "",
      alert: parseInt(formObject.alert, 10),
      m2mLoss: formObject.m2mLoss,
      orderLimit: formObject.orderLimit,
      m2mProfit: formObject.m2mProfit,
      ledgerView: ledgerView,
      tradeAllowed: tradeAllowed || formObject.tradeAllowed || "false",
      tradeBlockAbove: formObject.tradeBlockAbove || "",
      tradeBlockBelow: formObject.tradeBlockBelow || "",
    };
    if (formObject.adminType !== "CUSTOMER") {
      accountDetails = {
        partnership: parseInt(formObject.partnership, 10),
        onlyPositionSquareOff: accountDetails.onlyPositionSquareOff,
        rollOver: accountDetails.rollOver,
        onlyViewAccess: accountDetails.onlyViewAccess,
        ledgerView: accountDetails.ledgerView,
      };
    } else if (formObject.adminType === "CUSTOMER") {
      accountDetails = { ...accountDetails };
    }

    let subBrokerInfo1 = {
      brokerId: selectedBroker1.value,
      brokerPartnership: formObject.selectBroker1Partner || "",
    };
    let subBrokerInfo2 = {
      brokerId: selectedBroker2.value,
      brokerPartnership: formObject.selectBroker2Partner || "",
    };

    let marketAccess = {};
    // if (formObject.adminType === "CUSTOMER") {
    if (isCheckedGlobal) {
      if (formObject.adminType === "CUSTOMER") {
        marketAccess.globalSetting = {
          type: radioSelection || formObject.radioSelection || "",
          brokerageDetails: brokerageDetailsIndex,
          broker1: broker1INDEXData,
          broker2: broker2INDEXData,
          quantityDetails: quantitysettingsGLOBAL,

          marginDetails: {
            lot: marginDetailsINDEXLot,
            amount: marginDetailsINDEXAmount,
            maxMarginPerClient: maxMarginPerClientINDEX,
            // lot: marginDetails.lot,
            // amount: marginDetails.amount,
          },
          otherDetails: {
            allowedScripts: scriptDeatailsDropdownIndex,
            blockedScripts: blockedScriptDropdownIndex,
            scriptToWork: indexScriptToWork,
            freshLimit: indexFreshLimitAllowed,
          },
        };
      } else {
        marketAccess.globalSetting = {
          type: radioSelection || formObject.radioSelection || "",
          brokerageDetails: brokerageDetailsIndex,

          marginDetails: {
            lot: marginDetailsINDEXLot,
            amount: marginDetailsINDEXAmount,
            maxMarginPerClient: maxMarginPerClientINDEX,
            // lot: marginDetails.lot,
            // amount: marginDetails.amount,
          },
          otherDetails: {
            allowedScripts: scriptDeatailsDropdownIndex,
            blockedScripts: blockedScriptDropdownIndex,
            scriptToWork: indexScriptToWork,
            freshLimit: indexFreshLimitAllowed,
          },
        };
      }
    }

    if (isCheckedNSE) {
      if (formObject.adminType === "CUSTOMER") {
        marketAccess.nseSetting = {
          type: radioSelectionNSE || formObject.radioSelectionNSE || "",
          brokerageDetails: brokerageDetailsNSE,
          broker1: broker1NSEData,
          broker2: broker2NSEData,
          quantityDetails: quantitysettingsNSE,

          marginDetails: {
            lot: marginDetailsNSELot,
            amount: marginDetailsNSEAmount,
            maxMarginPerClient: maxMarginPerClientNSE,
          },
          otherDetails: {
            allowedScripts: scriptDeatailsDropdownNSE,
            blockedScripts: blockedScriptDropdownNSE,
            scriptToWork: NseScriptToWork,
            freshLimit: nseFreshLimitAllowed,
          },
        };
      } else {
        marketAccess.nseSetting = {
          type: radioSelectionNSE || formObject.radioSelectionNSE || "",
          brokerageDetails: brokerageDetailsNSE,

          marginDetails: {
            lot: marginDetailsNSELot,
            amount: marginDetailsNSEAmount,
            maxMarginPerClient: maxMarginPerClientNSE,
          },
          otherDetails: {
            allowedScripts: scriptDeatailsDropdownNSE,
            blockedScripts: blockedScriptDropdownNSE,
            scriptToWork: NseScriptToWork,
            freshLimit: nseFreshLimitAllowed,
          },
        };
      }
    }

    if (isCheckedMCX) {
      if (formObject.adminType === "CUSTOMER") {
        marketAccess.mcxSetting = {
          type: radioSelectionMCX || formObject.radioSelectionMCX || "",
          brokerageDetails: brokerageDetailsMCX,
          broker1: broker1MCXData,
          broker2: broker2MCXData,
          quantityDetails: quantitysettingsMCX,

          marginDetails: {
            lot: marginDetailsMCXLot,
            amount: marginDetailsMCXAmount,
            maxMarginPerClient: maxMarginPerClientMCX,
          },
          otherDetails: {
            allowedScripts: scriptDeatailsDropdownMCX,
            blockedScripts: blockedScriptDropdownMCX,
            scriptToWork: mcxScriptToWork,
            freshLimit: mcxFreshLimitAllowed,
          },
        };
      } else {
        marketAccess.mcxSetting = {
          type: radioSelectionMCX || formObject.radioSelectionMCX || "",
          brokerageDetails: brokerageDetailsMCXRatherThanCustomerType,

          marginDetails: {
            lot: marginDetailsMCXLot,
            amount: marginDetailsMCXAmount,
            maxMarginPerClient: maxMarginPerClientMCX,
            maxLotPerClient: maxLotPerClientMCX,
          },
          otherDetails: {
            allowedScripts: scriptDeatailsDropdownMCX,
            blockedScripts: blockedScriptDropdownMCX,
            scriptToWork: mcxScriptToWork,
            freshLimit: mcxFreshLimitAllowed,
          },
        };
      }
    }

    if (isCheckedNCDEX) {
      if (formObject.adminType === "CUSTOMER") {
        marketAccess.ncdexSetting = {
          type: radioSelectionNCDEX || formObject.radioSelectionNCDEX || "",
          brokerageDetails: brokerageDetailsNCDEX,
          broker1: broker1NCDEXData,
          broker2: broker2NCDEXData,
          quantityDetails: quantitysettingsGLOBAL,

          marginDetails: {
            lot: marginDetailsNCDEXLot,
            amount: marginDetailsNCDEXAmount,
            maxMarginPerClient: maxMarginPerClientNCDEX,
          },
          otherDetails: {
            allowedScripts: scriptDeatailsDropdownNCDEX,
            blockedScripts: blockedScriptDropdownNCDEX,
            scriptToWork: ncdexScriptToWork,
            freshLimit: ncdexFreshLimitAllowed,
          },
        };
      } else {
        marketAccess.ncdexSetting = {
          type: radioSelectionNCDEX || formObject.radioSelectionNCDEX || "",
          brokerageDetails: brokerageDetailsNCDEX,

          marginDetails: {
            lot: marginDetailsNCDEXLot,
            amount: marginDetailsNCDEXAmount,
            maxMarginPerClient: maxMarginPerClientNCDEX,
          },
          otherDetails: {
            allowedScripts: scriptDeatailsDropdownNCDEX,
            blockedScripts: blockedScriptDropdownNCDEX,
            scriptToWork: ncdexScriptToWork,
            freshLimit: ncdexFreshLimitAllowed,
          },
        };
      }
    }

    const jsonData = {
      adminType: formObject.adminType || "",
      firstName: formObject.firstName || "",
      lastName: formObject.lastName || "",
      email: formObject.email || "",
      password: formObject.password || "Abcd1234",
      city: formObject.city || "",
      contactNo: formObject.contactNo || "",
      accountDetails: accountDetails,
      marketAccess: marketAccess,
      remark: formObject.remark || "",
    };
    if (formObject.adminType === "CUSTOMER") {
      jsonData.adminId = adminId.adminId;
      jsonData.subBrokerInfo1 = subBrokerInfo1;
      jsonData.subBrokerInfo2 = subBrokerInfo2;

      signupservices
        .doNewCustomerAccount(jsonData)
        .then((resp) => {
          setIsLoading(false);
          if (resp.code === 0) {
            Swal.fire({
              title: "Error",
              text: resp.messages,
              icon: "error",
            });
          } else {
            const userName = resp.data.userName;
            const password = resp.data.password;
            Swal.fire({
              title: "Success!",
              html: `Account created successfully.<br> UserName: <b> ${userName} </b> <br> Password: <b> ${password} </b>`,
              icon: "success",
              confirmButtonText: "Okay",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text:
              error?.response?.data?.data?.errors[0]?.errorMessage ||
              "Network error!",
          });
        });
    } else {
      jsonData.parentAdminId = adminId.adminId;

      signupservices
        .doNewAdminAccount(jsonData)
        .then((resp) => {
          setIsLoading(false);
          if (resp.code === 0) {
            Swal.fire({
              title: "Error",
              text: resp.messages,
              icon: "error",
            });
          } else {
            const userName = resp.data.userName;
            const password = resp.data.password;
            Swal.fire({
              title: "Success!",
              html: `Account created successfully.<br> UserName: <b> ${userName} </b> <br> Password: <b> ${password} </b>`,
              icon: "success",
              confirmButtonText: "Okay",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text:
              error?.response?.data?.data?.errors[0]?.errorMessage ||
              "Network error!",
          });
        });
    }
  };

  const handleBrokerageScriptDropdown = (selectedOption, id) => {
    setInputFields((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForNSEBroker1 = (selectedOption, id) => {
    setInputFieldsForNSEBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForNSEBroker2 = (selectedOption, id) => {
    setInputFieldsForNSEBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForMCXBroker1 = (selectedOption, id) => {
    setInputFieldsForMCXBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForMCXBroker2 = (selectedOption, id) => {
    setInputFieldsForMCXBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForNCDEXBroker1 = (selectedOption, id) => {
    setInputFieldsForNCDEXBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForNCDEXBroker2 = (selectedOption, id) => {
    setInputFieldsForNCDEXBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForINDEXBroker1 = (selectedOption, id) => {
    setInputFieldsINDEXForBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForINDEXBroker2 = (selectedOption, id) => {
    setInputFieldsINDEXForBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const inputChangeBrokerageDetails = (e, field, id) => {
    const value = e.target.value;
    setInputFields((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsForNSERatherThanCustomerType = (
    e,
    field,
    id
  ) => {
    const value = e.target.value;
    setInputFieldsNSERatherThanCustomerType((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsForMCXRatherThanCustomerType = (
    e,
    field,
    id
  ) => {
    const value = e.target.value;
    setInputFieldsMCXRatherThanCustomerType((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsForNCDEXRatherThanCustomerType = (
    e,
    field,
    id
  ) => {
    const value = e.target.value;
    setInputFieldsNCDEXRatherThanCustomerType((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  
  const handleAddFields = () => {
    setInputFields([
        ...inputFields,
        { id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }
    ]);
};
  const handleAddFieldsMCXRatherThanCustomerType = () => {
    setInputFieldsMCXRatherThanCustomerType((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", mcxPercentage: "", mcxLot: "" },
      ];
    });
  };
  const handleAddFieldsNSERatherThanCustomerType = () => {
    setInputFieldsNSERatherThanCustomerType((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", nsePercentage: "", nseLot: "" },
      ];
    });
  };
  const handleAddFieldsNCDEXRatherThanCustomerType = () => {
    setInputFieldsNCDEXRatherThanCustomerType((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", ncdexPercentage: "", ncdexLot: "" },
      ];
    });
  };
  const handleAddFieldsForINDEXBroker1 = () => {
    setInputFieldsINDEXForBroker1((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForNSEBroker1 = () => {
    setInputFieldsForNSEBroker1((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForMCXBroker1 = () => {
    setInputFieldsForMCXBroker1((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForNCDEXBroker1 = () => {
    setInputFieldsForNCDEXBroker1((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForINDEXBroker2 = () => {
    setInputFieldsINDEXForBroker2((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForNSEBroker2 = () => {
    setInputFieldsForNSEBroker2((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForMCXBroker2 = () => {
    setInputFieldsForMCXBroker2((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForNCDEXBroker2 = () => {
    setInputFieldsForNCDEXBroker2((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };

  const handleRemoveField = (id) => {
    setInputFields((prevState) => prevState.filter((item) => item.id !== id));
  };
  const handleRemoveFieldMCXRatherThanCustomerType = (id) => {
    setInputFieldsMCXRatherThanCustomerType((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldNSERatherThanCustomerType = (id) => {
    setInputFieldsNSERatherThanCustomerType((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldNCDEXRatherThanCustomerType = (id) => {
    setInputFieldsNCDEXRatherThanCustomerType((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForINDEXBroker1 = (id) => {
    setInputFieldsINDEXForBroker1((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForNSEBroker1 = (id) => {
    setInputFieldsForNSEBroker1((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForNSEBroker2 = (id) => {
    setInputFieldsForNSEBroker2((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForMCXBroker1 = (id) => {
    setInputFieldsForMCXBroker1((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForMCXBroker2 = (id) => {
    setInputFieldsForMCXBroker2((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForNCDEXBroker1 = (id) => {
    setInputFieldsForNCDEXBroker1((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForNCDEXBroker2 = (id) => {
    setInputFieldsForNCDEXBroker2((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForINDEXBroker2 = (id) => {
    setInputFieldsINDEXForBroker2((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const fieldsToRenderINDEX =
    inputFields.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFields;
  const fieldsToRenderMCXRatherThanCustomerType =
    inputFieldsMCXRatherThanCustomerType.length === 0
      ? []
      : inputFieldsMCXRatherThanCustomerType;
  const fieldsToRenderNSERatherThanCustomerType =
    inputFieldsNSERatherThanCustomerType.length === 0
      ? []
      : inputFieldsNSERatherThanCustomerType;
  const fieldsToRenderNCDEXRatherThanCustomerType =
    inputFieldsNCDEXRatherThanCustomerType.length === 0
      ? []
      : inputFieldsNCDEXRatherThanCustomerType;
  const fieldsToRenderForNSEBroker1 =
    inputFieldsForNSEBroker1.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForNSEBroker1;
  const fieldsToRenderForNSEBroker2 =
    inputFieldsForNSEBroker2.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForNSEBroker2;
  const fieldsToRenderForMCXBroker1 =
    inputFieldsForMCXBroker1.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForMCXBroker1;
  const fieldsToRenderForMCXBroker2 =
    inputFieldsForMCXBroker2.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForMCXBroker2;
  const fieldsToRenderForNCDEXBroker1 =
    inputFieldsForNCDEXBroker1.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForNCDEXBroker1;
  const fieldsToRenderForNCDEXBroker2 =
    inputFieldsForNCDEXBroker2.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForNCDEXBroker2;
  const fieldsToRenderForINDEXBroker1 =
    inputFieldsForINDEXBroker1.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForINDEXBroker1;
  const fieldsToRenderForINDEXBroker2 =
    inputFieldsForINDEXBroker2.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForINDEXBroker2;

  const handleBrokerageScriptDropdownNSE = (selectedOption, id) => {
    setInputFieldsNSE((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const handleQtySettingScriptDropdownNSE = (selectedOption, id) => {
    setQuantitysettingsNSE((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              script: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

    const handleQtySettingScriptDropdownMCX = (selectedOption, id) => {
    setQuantitysettingsMCX((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              script: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

    const handleQtySettingScriptDropdownGLOBAL = (selectedOption, id) => {
    setQuantitysettingsGLOBAL((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              script: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const handleBrokerageScriptDropdownNSERatherThanCustomerType = (
    selectedOption,
    id
  ) => {
    setInputFieldsNSERatherThanCustomerType((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const inputChangeBrokerageDetailsNSE = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsNSE((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsNSEForBroker1 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForNSEBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsNSEForBroker2 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForNSEBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsMCXForBroker1 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForMCXBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsMCXForBroker2 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForMCXBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsNCDEXForBroker1 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForNCDEXBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsNCDEXForBroker2 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForNCDEXBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsINDEXForBroker1 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsINDEXForBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsINDEXForBroker2 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsINDEXForBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const handleAddFieldsNSE = () => {
    setInputFieldsNSE((prevFields) => [
      ...prevFields,
      { id: Date.now(), selectedScript: "", deliveryCom: "", intradayCom: "" },
    ]);
  };

  const handleRemoveFieldNSE = (id) => {
    setInputFieldsNSE((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const fieldsToRender =
    inputFieldsNSE.length === 0
      ? [
          {
            id: Date.now(),
            selectedScript: "",
            deliveryCom: "",
            intradayCom: "",
          },
        ]
      : inputFieldsNSE;

  const handleBrokerageScriptDropdownMCX = (selectedOption, id) => {
    setInputFieldsMCX((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownMCXRatherThanCustomerType = (
    selectedOption,
    id
  ) => {
    setInputFieldsMCXRatherThanCustomerType((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownNCDEXRatherThanCustomerType = (
    selectedOption,
    id
  ) => {
    setInputFieldsNCDEXRatherThanCustomerType((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const inputChangeQtySettingsNSE = (e, field, id) => {
    const value = e.target ? e.target.value : e.value;

    setQuantitysettingsNSE((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const inputChangeQtySettingsMCX = (e, field, id) => {
    const value = e.target ? e.target.value : e.value;

    setQuantitysettingsMCX((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const inputChangeQtySettingsGLOBAL = (e, field, id) => {
    const value = e.target ? e.target.value : e.value;

    setQuantitysettingsGLOBAL((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };


  const inputChangeBrokerageDetailsMCX = (e, field, id) => {
    const value = e.target ? e.target.value : e.value;

    setInputFieldsMCX((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const handleAddFieldsNSEQtySettings = () => {
    setQuantitysettingsNSE([
        ...quantitysettingsNSE,
        { id: Date.now(), segment: "NSE", script:"", type:"QTY", minOrder: null, maxOrder: null, positionLimit: null }
    ]);
  };

    const handleAddFieldsMCXQtySettings = () => {
    setQuantitysettingsMCX([
        ...quantitysettingsMCX,
        { id: Date.now(), segment: "MCX", script:"", type:"LOT", minOrder: null, maxOrder: null, positionLimit: null }
    ]);
  };

    const handleAddFieldsGLOBALQtySettings = () => {
    setQuantitysettingsGLOBAL([
        ...quantitysettingsGLOBAL,
        { id: Date.now(), segment: "GLOBAL", script:"", type:"QTY", minOrder: null, maxOrder: null, positionLimit: null }
    ]);
  };

 
  const handleAddFieldsMCX = () => {
    setInputFieldsMCX([
        ...inputFieldsMCX,
        { id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }
    ]);
};

  const handleRemoveFieldQtyNSE = (id) => {
    setQuantitysettingsNSE((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };

    const handleRemoveFieldQtyMCX = (id) => {
    setQuantitysettingsMCX((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };

    const handleRemoveFieldQtyGLOBAL = (id) => {
    setQuantitysettingsGLOBAL((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };

  const handleRemoveFieldMCX = (id) => {
    setInputFieldsMCX((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const fieldsToRenderMCX =
    inputFieldsMCX.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsMCX;

  const fieldsToRenderQtySettingsNSE =
    quantitysettingsNSE.length === 0
      ? [{ id: 1, segment: "NSE", script: "ALL", type:"QTY", minOrder: 0, maxOrder: 0, positionLimit: 0 }]
      : quantitysettingsNSE;

  const fieldsToRenderQtySettingsMCX =
    quantitysettingsMCX.length === 0
      ? [{ id: 1, segment: "MCX", script: "ALL", type:"LOT", minOrder: 0, maxOrder: 0, positionLimit: 0 }]
      : quantitysettingsMCX;
  
  const fieldsToRenderQtySettingsGLOBAL =
    quantitysettingsGLOBAL.length === 0
      ? [{ id: 1, segment: "GLOBAL", script: "ALL", type:"QTY", minOrder: 0, maxOrder: 0, positionLimit: 0 }]
      : quantitysettingsGLOBAL;

  const handleBrokerageScriptDropdownNCDEX = (selectedOption, id) => {
    setInputFieldsNCDEX((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const inputChangeBrokerageDetailsNCDEX = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsNCDEX((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const handleAddFieldsNCDEX = () => {
    setInputFieldsNCDEX((prevFields) => {
      const newId =
        prevFields.length > 0
          ? Math.max(...prevFields.map((field) => field.id)) + 1
          : 1;

      return [
        ...prevFields,
        { id: newId, selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };

  const handleRemoveFieldNCDEX = (id) => {
    setInputFieldsNCDEX((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const fieldsToRenderNCDEX =
    inputFieldsNCDEX.length === 0
      ? [
          {
            id: Date.now(),
            selectedScript: "",
            deliveryCom: "",
            intradayCom: "",
          },
        ]
      : inputFieldsNCDEX;

  const handleCopySettingDropdown = (selected) => {
    setSelectedOption(selected);
  };
  const handleCopySettingDropdownINDEXForBrokerageDetails = (selected) => {
    setCopySettingINDEXForBrokerageDetails(selected);
  };
  const handleCopySettingDropdownINDEXForMarginDetails = (selected) => {
    setCopySettingINDEXForMarginDetails(selected);
  };
  const handleCopySettingDropdownINDEXForOtherDetails = (selected) => {
    setCopySettingINDEXForOtherDetails(selected);
  };

  const handleCopySettingDropdownMCXorBrokerageDetails = (selected) => {
    setCopySettingMCXForBrokerageDetails(selected);
  };
  const handleCopySettingDropdownMCXForMarginDetails = (selected) => {
    setCopySettingMCXForMarginDetails(selected);
  };
  const handleCopySettingDropdownMCXForOtherDetails = (selected) => {
    setCopySettingMCXForOtherDetails(selected);
  };

  const handleCopySettingDropdownNSEForQuantitySettings = (selected) => {
    setCopySettingNSEForQuantitySettings(selected); 
    if(selected?.value){
      QuantitySettingsService.getQuantitySettings({"userId" : selected.value, "segment":"NSE"}).then(res => {
            if (res.code === 1) {
              const details = res.data.quantitySettings.quantityDetails;
              if (details.length > 0) {
                 const enrichedDetails = details.map((item, index) => ({
                ...item, // keep existing fields
                id: Date.now() + index, // add id (unique)
              }));
                setQuantitysettingsNSE(enrichedDetails);
              } else{
                setQuantitysettingsNSE([]);
              }
            } 
          });
        } else{
          setQuantitysettingsNSE([]);
        }
  };

  const handleCopySettingDropdownMCXForQuantitySettings = (selected) => {
    setCopySettingMCXForQuantitySettings(selected); 
    if(selected?.value){
      QuantitySettingsService.getQuantitySettings({"userId" : selected.value, "segment":"MCX"}).then(res => {
            if (res.code === 1) {
              const details = res.data.quantitySettings.quantityDetails;
              if (details.length > 0) {
                 const enrichedDetails = details.map((item, index) => ({
                ...item, // keep existing fields
                id: Date.now() + index, // add id (unique)
              }));
                setQuantitysettingsMCX(enrichedDetails);
              } else{
                setQuantitysettingsMCX([]);
              }
            } 
          });
        } else{
          setQuantitysettingsMCX([]);
        }
  };

  const handleCopySettingDropdownGLOBALForQuantitySettings = (selected) => {
    setCopySettingGLOBALForQuantitySettings(selected); 
    if(selected?.value){
      QuantitySettingsService.getQuantitySettings({"userId" : selected.value, "segment":"GLOBAL"}).then(res => {
            if (res.code === 1) {
              const details = res.data.quantitySettings.quantityDetails;
              if (details.length > 0) {
                 const enrichedDetails = details.map((item, index) => ({
                ...item, // keep existing fields
                id: Date.now() + index, // add id (unique)
              }));
                setQuantitysettingsGLOBAL(enrichedDetails);
              } else{
                setQuantitysettingsGLOBAL([]);
              }
            } 
          });
        } else{
          setQuantitysettingsGLOBAL([]);
        }
  };

  const handleSubBroker1Dropdown = (selectedOption) => {
    setSelectedBroker1(selectedOption);
  };
  const handleSubBroker2Dropdown = (selectedOption) => {
    setSelectedBroker2(selectedOption);
  };
  const handleScriptDetailsDropdownINDEX = (selectedOptions) => {
    setScriptDeatailsDropdownIndex(
      selectedOptions ? selectedOptions?.map((option) => option.value) : []
    );
  };

  const handleBlockedScriptDropdownIndex = (selectedOptions) => {
    setBlockedScriptDropdownIndex(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  const handleRadioSelection = (selection) => {
    setMarginDetailsRadioSelection(selection);
   
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setMarginDetailsDelivery(value);

    if (marginDetailsRadioSelection === "LOT") {
      setMarginDetails({ lot: value, amount: 0 });
    } else if (marginDetailsRadioSelection === "AMOUNT") {
      setMarginDetails({ lot: 0, amount: value });
    }
  };
  const handleCopySettingDropdownMCX = (selected) => {
    setSelectedOptionMCX(selected);
  };

  const handleScriptDetailsDropdownMCX = (selectedOptions) => {
    setScriptDeatailsDropdownMCX(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const handleBlockedScriptDropdownMCX = (selectedOptions) => {
    setBlockedScriptDropdownMCX(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  const handleRadioSelectionMCX = (selection) => {
    setMarginDetailsRadioSelectionMCX(selection);
    if (selection === "LOT") {
      setMarginDetailsMCX({ lot: marginDetailsDeliveryMCX, amount: 0 });
    } else if (selection === "AMOUNT") {
      setMarginDetailsMCX({ lot: 0, amount: marginDetailsDeliveryMCX });
    }
  };

  const handleInputChangeMCX = (e) => {
    const value = e.target.value;
    setMarginDetailsDeliveryMCX(value);

    if (marginDetailsRadioSelectionMCX === "LOT") {
      setMarginDetailsMCX({ lot: value, amount: 0 });
    } else if (marginDetailsRadioSelectionMCX === "AMOUNT") {
      setMarginDetailsMCX({ lot: 0, amount: value });
    }
  };

  const handleCopySettingDropdownNSEForBrokerageDetails = (selected) => {
    setCopySettingNSEForBrokerageDetails(selected);
  };
  const handleCopySettingDropdownNSEForMarginDetails = (selected) => {
    setCopySettingNSEForMarginDetails(selected);
  };
  const handleCopySettingDropdownNSEForOtherDetails = (selected) => {
    setCopySettingNSEForOtherDetails(selected);
  };
  const handleCopySettingDropdownNSE = (selected) => {
    setSelectedOptionNSE(selected);
  };

  const handleScriptDetailsDropdownNSE = (selectedOptions) => {
    setScriptDeatailsDropdownNSE(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const handleBlockedScriptDropdownNSE = (selectedOptions) => {
    setBlockedScriptDropdownNSE(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  const handleRadioSelectionNSE = (selection) => {
    setMarginDetailsRadioSelectionNSE(selection);

  };

  const handleCopySettingDropdownNCDEXorBrokerageDetails = (selected) => {
    setCopySettingNCDEXForBrokerageDetails(selected);
  };
  const handleCopySettingDropdownNCDEXForMarginDetails = (selected) => {
    setCopySettingNCDEXForMarginDetails(selected);
  };
  const handleCopySettingDropdownNCDEXForOtherDetails = (selected) => {
    setCopySettingNCDEXForOtherDetails(selected);
  };
  const handleCopySettingDropdownNCDEX = (selected) => {
    setSelectedOptionNCDEX(selected);
  };

  const handleScriptDetailsDropdownNCDEX = (selectedOptions) => {
    setScriptDeatailsDropdownNCDEX(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const handleBlockedScriptDropdownNCDEX = (selectedOptions) => {
    setBlockedScriptDropdownNCDEX(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  const handleRadioSelectionNCDEX = (selection) => {
    setMarginDetailsRadioSelectionNCDEX(selection);
    // if (selection === "LOT") {
    //   setMarginDetailsNCDEX({ lot: marginDetailsDeliveryNCDEX, amount: 0 });
    // } else if (selection === "AMOUNT") {
    //   setMarginDetailsNCDEX({ lot: 0, amount: marginDetailsDeliveryNCDEX });
    // }
  };

  const handleInputChangeNCDEX = (e) => {
    const value = e.target.value;
    setMarginDetailsDeliveryNCDEX(value);

    if (marginDetailsRadioSelectionNCDEX === "LOT") {
      setMarginDetailsNCDEX({ lot: value, amount: 0 });
    } else if (marginDetailsRadioSelectionNCDEX === "AMOUNT") {
      setMarginDetailsNCDEX({ lot: 0, amount: value });
    }
  };

  const [selectedOptionDefault, setSelectedOptionDefault] = useState("");
  const [optionsDefaultSetting, setOptionsDefaultSetting] = useState([]);

  useEffect(() => {
    DefaultSettingServices.getSettings({ adminId: adminId.adminId }).then(
      (res) => {
        if (res.code === 1) {
          if (res.data.settingList.length > 0) {
            setOptionsDefaultSetting(res.data.settingList);
          } else {
            setOptionsDefaultSetting([]);
          }
        }
      }
    );
  }, []);
  const optionsDefault = optionsDefaultSetting.map((item) => ({
    value: item.settingId,
    label: item.settingName,
  }));
  const handleSelectChange = (selected) => {
    setSelectedOptionDefault(selected);
    if (selected) {
      const selectedSetting = optionsDefaultSetting.find(
        (item) => item.settingId === selected.value
      );

      setFormData({
        settingName: selectedSetting.settingName || "",
        partnership: selectedSetting.accountDetails?.partnership || "",
        brokerage: selectedSetting.accountDetails?.brokerage || "",
        alert: selectedSetting.accountDetails?.alert || "",
        orderLimit: selectedSetting.accountDetails?.orderLimit || "",
        squareOffDisabledInMin:
          selectedSetting.accountDetails?.squareOffDisabledInMin || "",
        m2mLoss: selectedSetting.accountDetails?.m2mLoss || "",
        m2mProfit: selectedSetting.accountDetails?.m2mProfit || "",
        tradeBlockAbove: selectedSetting.accountDetails?.tradeBlockAbove || "",
        tradeBlockBelow: selectedSetting.accountDetails?.tradeBlockBelow || "",
        password: "Abcd1234",
      });

      if (selectedSetting.segments) {
        if (selectedSetting.segments.includes("global")) {
          setIsCheckedGlobal(true);
        }
        if (selectedSetting.segments.includes("mcx")) {
          setIsCheckedMCX(true);
        }
        if (selectedSetting.segments.includes("nse")) {
          setIsCheckedNSE(true);
        }
        if (selectedSetting.segments.includes("ncdex")) {
          setIsCheckedNCDEX(true);
        }
      }

      if (
        selectedSetting.marketAccess &&
        selectedSetting.marketAccess.globalSetting 
      ) {
        const brokerageDetails =
          selectedSetting.marketAccess.globalSetting.brokerageDetails;
        
        const updatedFields = brokerageDetails.map((item) => ({
          id: uuidv4(),
          selectedScript: item.script,
          deliveryCom: item.deliveryCom,
          intradayCom: item.intradayCom,
        }));

        setInputFields(updatedFields);

        const handleDeleteindex = (idToDelete) => {
          const updatedFields = inputFields.filter(
            (item) => item.id !== idToDelete
          );
          setInputFields(updatedFields);
        };
        const { lot, amount } =
          selectedSetting.marketAccess.globalSetting.marginDetails || {};
        setMarginDetails({ lot, amount });
        setMarginDetailsINEDXLot(lot);
        setMarginDetailsINDEXAmount(amount);
        if (lot > 0) {
          setMarginDetailsRadioSelection("LOT");
          setMarginDetailsDelivery(lot);
        } else if (amount > 0) {
          setMarginDetailsRadioSelection("AMOUNT");
          setMarginDetailsDelivery(amount);
        }

        const scriptDetailsindex =
        selectedSetting.marketAccess.globalSetting.otherDetails || {};
        const blockedScriptsindex = scriptDetailsindex.blockedScripts || [];
        const allowedScriptsindex = scriptDetailsindex.allowedScripts || [];

        const blockedScriptOptionsindex = blockedScriptsindex.map((script) => ({
          value: script,
          label: script,
        }));
        const allowedScriptOptionsindex = allowedScriptsindex.map((script) => ({
          value: script,
          label: script,
        }));

        if (blockedScriptsindex.length > 0) {
          setScriptDetailsRadioSelection("BLOCK");
          setBlockedScriptDropdownIndex(
            blockedScriptOptionsindex.map((script) => script.value)
          );
        } 
        if(allowedScriptsindex?.length>0) {
          setScriptDetailsRadioSelection("ALLOW");
          setScriptDeatailsDropdownIndex(
            allowedScriptOptionsindex.map((script) => script.value)
          );
        }
      }
      if (
        selectedSetting.marketAccess &&
        selectedSetting.marketAccess.mcxSetting 
      ) {
        const brokerageDetails =
          selectedSetting.marketAccess.mcxSetting.brokerageDetails;

        const updatedFields = brokerageDetails.map((item) => ({
          id: uuidv4(),
          selectedScript: item.script,
          deliveryCom: item.deliveryCom,
          intradayCom: item.intradayCom,
        }));

        setInputFieldsMCX(updatedFields);

        const handleDelete = (idToDelete) => {
          const updatedFields = inputFieldsMCX.filter(
            (item) => item.id !== idToDelete
          );
          setInputFieldsMCX(updatedFields);
        };
        const { lot, amount } =
          selectedSetting.marketAccess.mcxSetting.marginDetails || {};
        setMarginDetailsMCX({ lot, amount });
        setMarginDetailsMCXLot(lot);
        setMarginDetailsMCXAmount(amount);

        if (lot > 0) {
          setMarginDetailsRadioSelectionMCX("LOT");
          setMarginDetailsDeliveryMCX(lot);
        } else if (amount > 0) {
          setMarginDetailsRadioSelectionMCX("AMOUNT");
          setMarginDetailsDeliveryMCX(amount);
        }
        const scriptDetails =
          selectedSetting.marketAccess.mcxSetting.otherDetails || {};
        const blockedScripts = scriptDetails.blockedScripts || [];
        const allowedScripts = scriptDetails.allowedScripts || [];

        const blockedScriptOptions = blockedScripts.map((script) => ({
          value: script,
          label: script,
        }));
        const allowedScriptOptions = allowedScripts.map((script) => ({
          value: script,
          label: script,
        }));

        if (blockedScripts.length > 0) {
          setScriptDetailsRadioSelectionMCX("BLOCK");
          setBlockedScriptDropdownMCX(
            blockedScriptOptions.map((script) => script.value)
          );
        } 
        if(allowedScripts?.length>0) {
          setScriptDetailsRadioSelectionMCX("ALLOW");
          setScriptDeatailsDropdownMCX(
            allowedScriptOptions.map((script) => script.value)
          );
        }
      }

      if (
        selectedSetting.marketAccess &&
        selectedSetting.marketAccess.nseSetting 
      ) {
        const brokerageDetails =
          selectedSetting.marketAccess.nseSetting.brokerageDetails;

        const updatedFields = brokerageDetails.map((item) => ({
          id: uuidv4(),
          selectedScript: item.script,
          deliveryCom: item.deliveryCom,
          intradayCom: item.intradayCom,
        }));

        setInputFieldsNSE(updatedFields);

        const handleDeletense = (idToDelete) => {
          
          const updatedFields = inputFieldsNSE.filter(
            (item) => item.id !== idToDelete
          );
          setInputFieldsNSE(updatedFields);
        };
        const { lot, amount } =
          selectedSetting.marketAccess.nseSetting.marginDetails || {};
        // setMarginDetailsNSE({ lot, amount });
        setMarginDetailsNSELot(lot);
        setMarginDetailsNSEAmount(amount);

        if (lot > 0) {
          setMarginDetailsRadioSelectionNSE("LOT");
          setMarginDetailsDeliveryNSE(lot);
        } else if (amount > 0) {
          setMarginDetailsRadioSelectionNSE("AMOUNT");
          setMarginDetailsDeliveryNSE(amount);
        }

        const scriptDetailsnse =
          selectedSetting.marketAccess.nseSetting.otherDetails || {};
        const blockedScriptsnse = scriptDetailsnse.blockedScripts || [];
        const allowedScriptsnse = scriptDetailsnse.allowedScripts || [];

        const blockedScriptOptionsnse = blockedScriptsnse.map((script) => ({
          value: script,
          label: script,
        }));
        const allowedScriptOptionsnse = allowedScriptsnse.map((script) => ({
          value: script,
          label: script,
        }));

        if (blockedScriptsnse.length > 0) {
          setScriptDetailsRadioSelectionNSE("BLOCK");
          setBlockedScriptDropdownNSE(
            blockedScriptOptionsnse.map((script) => script.value)
          );
        } 
        if(allowedScriptsnse?.length>0) {
          setScriptDetailsRadioSelectionNSE("ALLOW");
          setScriptDeatailsDropdownNSE(
            allowedScriptOptionsnse.map((script) => script.value)
          );
        }
      }

      if (
        selectedSetting.marketAccess &&
        selectedSetting.marketAccess.ncdexSetting &&
        selectedSetting.marketAccess.ncdexSetting.brokerageDetails
      ) {
        const brokerageDetails =
          selectedSetting.marketAccess.ncdexSetting.brokerageDetails;

        const updatedFields = brokerageDetails.map((item) => ({
          id: uuidv4(),
          selectedScript: item.script,
          deliveryCom: item.deliveryCom,
          intradayCom: item.intradayCom,
        }));

        setInputFieldsNCDEX(updatedFields);

        const handleDeletencdex = (idToDelete) => {
          
          const updatedFields = inputFieldsNCDEX.filter(
            (item) => item.id !== idToDelete
          );
          setInputFieldsNCDEX(updatedFields);
        };
        const { lot, amount } =
          selectedSetting.marketAccess.ncdexSetting.marginDetails || {};
        setMarginDetailsNCDEX({ lot, amount });
        setMarginDetailsNCDEXLot(lot);
        setMarginDetailsNCDEXAmount(amount);

        if (lot > 0) {
          setMarginDetailsRadioSelectionNCDEX("LOT");
          setMarginDetailsDeliveryNCDEX(lot);
        } else if (amount > 0) {
          setMarginDetailsRadioSelectionNCDEX("AMOUNT");
          setMarginDetailsDeliveryNCDEX(amount);
        }

        const scriptDetailsncdex =
          selectedSetting.marketAccess.ncdexSetting.scriptDetails || {};
        const blockedScriptsncdex = scriptDetailsncdex.blockedScripts || [];
        const allowedScriptsncdex = scriptDetailsncdex.allowedScripts || [];

        const blockedScriptOptionsncdex = blockedScriptsncdex.map((script) => ({
          value: script,
          label: script,
        }));
        const allowedScriptOptionsncdex = allowedScriptsncdex.map((script) => ({
          value: script,
          label: script,
        }));

        if (blockedScriptsncdex.length > 0) {
          setScriptDetailsRadioSelectionNCDEX("BLOCK");
          setBlockedScriptDropdownNCDEX(
            blockedScriptOptionsncdex.map((script) => script.value)
          );
        } else {
          setScriptDetailsRadioSelectionNCDEX("ALLOW");
          setScriptDeatailsDropdownNCDEX(
            allowedScriptOptionsncdex.map((script) => script.value)
          );
        }
      }

      setOrderHighLow(selectedSetting.accountDetails.orderHighLow || false);
      setAutoSquare(selectedSetting.accountDetails.applyAutoSquare || false);
      setIntraDayAutoSquare(
        selectedSetting.accountDetails.intradaySquare || false
      );
      setOnlyPositionSquare(
        selectedSetting.accountDetails.onlyPositionSquareOff || false
      );
      setRollOver(selectedSetting.accountDetails.rollOver || false);
      setOnlyViewAccess(selectedSetting.accountDetails.onlyViewAccess || false);
      setBandScriptAllow(
        selectedSetting.accountDetails.bandScriptAllow || false
      );
      setLedgerView(selectedSetting.accountDetails.ledgerView || false);
      setTradeAllowed(selectedSetting.accountDetails.tradeAllowed || false);
    } else {
      setFormData({
        settingName: "",
        partnership: "",
        brokerage: "",
        alert: "",
        orderLimit: "",
        squareOffDisabledInMin: "",
        m2mLoss: "",
        m2mProfit: "",
        tradeBlockAbove: "",
        tradeBlockBelow: "",
        segments: [],
      });

      // Reset checkboxes and other state
      setIsCheckedGlobal(false);
      setIsCheckedMCX(false);
      setIsCheckedNSE(false);
      setIsCheckedNCDEX(false);

      // Clear dynamic input fields
      setInputFields([]);
      setInputFieldsMCX([]);
      setInputFieldsNSE([]);
      setInputFieldsNCDEX([]);

      // Clear margin details
      setMarginDetails({ lot: "", amount: "" });
      setMarginDetailsMCX({ lot: "", amount: "" });
      // setMarginDetailsNSE({ lot: '', amount: '' });
      setMarginDetailsNCDEX({ lot: "", amount: "" });

      // Reset flags
      setOrderHighLow(false);
      setAutoSquare(false);
      setIntraDayAutoSquare(false);
      setOnlyPositionSquare(false);
      setRollOver(false);
      setOnlyViewAccess(false);
      setBandScriptAllow(false);
      setLedgerView(true);
      setTradeAllowed(false);
    }
  };

  const toCamelCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word, index) => word.charAt(0).toUpperCase() + word.slice(1) + " ")
      .join("");
  };

  return (
    <div
      className={
        isMobile
          ? "container-fluid mb-5 ps-0 pe-0 bg-white"
          : "container-fluid mb-5"
      }
    >
      <Form onSubmit={(e) => doNewAccount(e)} id="signup-form" className="pt-1">
        <input type="hidden" name="parentAdminId" value="admin1" />
        <input type="hidden" name="adminId" value="admin1" />
        <div>
          <Card className="mt-0">
            <Card.Body className="mt-0 pt-0">
              <Row>
                <lagend className="fieldset-legend-title label-color">
                  BASIC DETAILS
                </lagend>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} xl={3} xs={12} controlId="formBasicType">
                  <Form.Label
                    className={`fss-875 label-color mb-1 ${
                      !isMobile ? "mt-2" : ""
                    }`}
                  >
                    ACCOUNT TYPE{" "}
                    <b style={{ fontSize: "0.9rem", color: "red" }}>*</b>
                  </Form.Label>
                  <Form.Select
                    name="adminType"
                    className="form-control bg-white text-black mt-0 select-color"
                    size="sm"
                    onChange={adminChange2}
                    value={selectedRole}
                    required
                  >
                    <option value="">Select</option>
                    {adminId.adminType === "SUPER_ADMIN" || adminId.adminType == 'SUPER_MASTER' ? (
                      <option value="ADMIN">ADMIN</option>
                    ) : null}
                    {adminId.adminType === "SUPER_ADMIN" ||
                    adminId.adminType === "ADMIN" || adminId.adminType == 'SUPER_MASTER' ? (
                      <option value="MASTER">MASTER</option>
                    ) : null}
                    
                    {adminId.adminType !== "SUBBROKER" ? (
                      <option value="SUBBROKER">BROKER</option>
                    ) : null}
                    <option value="CUSTOMER">CUSTOMER</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group
                  as={Col}
                  xs={12}
                  sm={3}
                  className="mt-2"
                  controlId="formBasicfirstName"
                >
                  <Form.Label className="fss-875 label-color mb-1">
                    ACCOUNT NAME{" "}
                    <b style={{ fontSize: "0.9rem", color: "red" }}> *</b>
                  </Form.Label>
                  <Form.Control
                    className="bg-white custom-placeholder value-color"
                    type="text"
                    size="sm"
                    placeholder="ENTER ACCOUNT NAME"
                    name="firstName"
                    required
                    value={formData.firstName}
                    onChange={handleChange}
                    onBlur={(e) => validateField(e.target.name, e.target.value)}
                    isInvalid={!!errors.firstName}
                    minLength={4}
                    maxLength={20}
                    title="Account name must be between 4 to 20 characters."
                  />
                </Form.Group>

                <Form.Group
                  as={Col}
                  xs={12}
                  sm={3}
                  className="mt-2"
                  controlId="formGridPassword"
                >
                  <Form.Label className="fss-875 label-color mb-1">
                    PASSWORD
                    <b style={{ fontSize: "0.9rem", color: "red" }}> *</b>
                  </Form.Label>
                  <Form.Control
                    className="bg-white value-color custom-placeholder"
                    size="sm"
                    type="text"
                    placeholder="Enter Password"
                    name="password"
                    required
                    value={formData.password || ""}
                    onChange={handleChange}
                    onBlur={(e) => validateField(e.target.name, e.target.value)}
                    isInvalid={!!errors.password}
                    minLength={4}
                    maxLength={10}
                    title="Password must be between 4 to 10 characters."
                  />
                </Form.Group>
              </Row>
              <Row>
                <Col
                  sm={3}
                  xl={4}
                  xs={12}
                  className={`fss-875 label-color mb-1`}
                >
                  LEDGER VIEW
                  <Form>
                    {["radio"].map((type) => (
                      <div
                        key={`inline-${type}`}
                        className={isMobile ? "mb-3 ms-1" : " mb-3"}
                      >
                        <Form.Check
                          className="custom-radio label-color fss-875"
                          inline
                          label="YES"
                          name="ledgerView"
                          value="YES"
                          type={type}
                          checked={ledgerView === true}
                          onChange={() => handleRadioChange(true)}
                        />
                        <Form.Check
                          className="custom-radio label-color fss-875"
                          inline
                          label="NO"
                          name="ledgerView"
                          value="NO"
                          type={type}
                          checked={ledgerView === false}
                          onChange={() => handleRadioChange(false)}
                        />
                      </div>
                    ))}
                  </Form>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
        {selectedRole !== "" && selectedRole !== "SELECT ROLE" && (
          <div>
            {selectedRole !== "SUBBROKER" && (
              <>
                <div id="customerAccountDetails">
                  <Card className="mt-1 pt-0">
                    <Card.Body className="pt-1">
                      <Row>
                        <lagend className="fieldset-legend-title label-color">
                          ACCOUNT DETAILS
                        </lagend>
                      </Row>
                      <div>
                        {selectedRole !== "CUSTOMER" && (
                          <>
                            <Row className="mt-2">
                              <Col sm={3} className="fss-875 label-color">
                                PARTNERSHIP(%)
                                <b style={{ fontSize: "0.9rem", color: "red" }}>
                                  *
                                </b>{" "}
                              </Col>
                              <Col sm={2}>
                                <InputGroup size="sm" className="mb-3">
                                  <Form.Control
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white text-black custom-placeholder"
                                    placeholder="Partnership(%)"
                                    name="partnership"
                                    type="number"
                                    required
                                    value={formData.partnership}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      if (
                                        parseFloat(value) < 1 &&
                                        value !== ""
                                      ) {
                                        return; // Prevent updating state if the value is less than 1
                                      }

                                      handleChange(e);
                                    }}
                                    onBlur={(e) => {
                                      validateField(
                                        e.target.name,
                                        e.target.value
                                      );

                                      if (parseFloat(e.target.value) < 1) {
                                        setErrors((prevErrors) => ({
                                          ...prevErrors,
                                          partnership:
                                            "Partnership must be greater than or equal to 1",
                                        }));
                                      }
                                    }}
                                    isInvalid={!!errors.partnership}
                                  />
                                </InputGroup>
                              </Col>
                              <Col sm={1}></Col>
                            </Row>
                          </>
                        )}
                        {selectedRole === "CUSTOMER" && (
                          <>
                            <Row className="mt-2">
                              <Col
                                sm={3}
                                xs={5}
                                className="fss-875 label-color"
                              >
                                <label className="mt-1">SELECT SETTING </label>
                              </Col>
                              <Col sm={2} xs={7}>
                                <Select
                                  id="react-select"
                                  value={selectedOptionDefault}
                                  onChange={handleSelectChange}
                                  options={optionsDefault}
                                  placeholder="Select"
                                  className="select-color"
                                  styles={customStyles}
                                  theme={the}
                                  isClearable
                                />
                              </Col>
                              <Col sm={1}></Col>
                              <Col sm={1}></Col>
                            </Row>
                          </>
                        )}
                        {selectedRole === "CUSTOMER" && (
                          <>
                            <Row className="mt-2">
                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color"
                              >
                                <b>ORDER BETWEEN HIGH LOW </b>
                              </Col>
                              <Col sm={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-3 ps-0 pe-0 text-right"
                                          : "ms-1 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        label="YES"
                                        name="orderHighLow"
                                        value="YES"
                                        type={type}
                                        inline
                                        checked={orderHighLow === true}
                                        onChange={() => setOrderHighLow(true)}
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        type={type}
                                        label="NO"
                                        name="orderHighLow"
                                        value="NO"
                                        inline
                                        checked={orderHighLow === false}
                                        onChange={() => setOrderHighLow(false)}
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color"
                              >
                                <b>APPLY AUTO SQUARE </b>
                              </Col>
                              <Col sm={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-3 ps-0 pe-0 text-right"
                                          : "ms-1 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="YES"
                                        name="autoSquare"
                                        value="YES"
                                        type={type}
                                        checked={applyAutoSquare === true}
                                        onChange={() => setAutoSquare(true)}
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="NO"
                                        name="autoSquare"
                                        value="NO"
                                        type={type}
                                        checked={applyAutoSquare === false}
                                        onChange={() => setAutoSquare(false)}
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                            </Row>
                          </>
                        )}
                        <Row className="mt-0">
                          {selectedRole === "CUSTOMER" && (
                            <>
                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color"
                              >
                                <b>INTRA DAY AUTO SQUARE </b>
                              </Col>
                              <Col sm={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-3 ps-0 pe-0 text-right"
                                          : "ms-4 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio ps-0 pe-0 label-color fss-875"
                                        type={type}
                                        label="YES"
                                        name="intraDayAutoSquare"
                                        value="YES"
                                        inline
                                        checked={intraDayAutoSquare === true}
                                        onChange={() =>
                                          setIntraDayAutoSquare(true)
                                        }
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        type={type}
                                        label="NO"
                                        name="intraDayAutoSquare"
                                        value="NO"
                                        inline
                                        checked={intraDayAutoSquare === false}
                                        onChange={() =>
                                          setIntraDayAutoSquare(false)
                                        }
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                            </>
                          )}
                          <Col sm={3} xs={7} className="fss-875 label-color">
                            <b>ONLY POSITION SQUAREOFF</b>
                          </Col>
                          <Col sm={3} xs={5}>
                            <Form>
                              {["radio"].map((type) => (
                                <div
                                  key={`inline-${type}`}
                                  className={
                                    isMobile
                                      ? "mb-3 ps-0 pe-0 text-right"
                                      : "ms-4 mb-3"
                                  }
                                >
                                  <Form.Check
                                    className="custom-radio ps-0 pe-0 label-color fss-875"
                                    type={type}
                                    label="YES"
                                    name="onlyPositionSquare"
                                    value="YES"
                                    inline
                                    checked={onlyPositionSquareOff === true}
                                    onChange={() => setOnlyPositionSquare(true)}
                                  />
                                  <Form.Check
                                    className="custom-radio label-color fss-875"
                                    type={type}
                                    label="NO"
                                    name="onlyPositionSquare"
                                    value="NO"
                                    inline
                                    checked={onlyPositionSquareOff === false}
                                    onChange={() =>
                                      setOnlyPositionSquare(false)
                                    }
                                  />
                                </div>
                              ))}
                            </Form>
                          </Col>
                        </Row>
                        <Row className="mt-0">
                          <Col sm={3} xs={7} className="fss-875 label-color">
                            <b>ROLL OVER </b>
                          </Col>
                          <Col sm={3} xs={5}>
                            <Form>
                              {["radio"].map((type) => (
                                <div
                                  key={`inline-${type}`}
                                  className={
                                    isMobile
                                      ? "mb-3 ps-0 pe-0 text-right"
                                      : "ms-4 mb-3"
                                  }
                                >
                                  <Form.Check
                                    className="custom-radio ps-0 pe-0 label-color fss-875"
                                    inline
                                    label="YES"
                                    name="rollOver"
                                    value="YES"
                                    type={type}
                                    checked={rollOver === true}
                                    onChange={() => setRollOver(true)}
                                  />
                                  <Form.Check
                                    className="custom-radio label-color fss-875"
                                    inline
                                    label="NO"
                                    name="rollOver"
                                    value="NO"
                                    type={type}
                                    checked={rollOver === false}
                                    onChange={() => setRollOver(false)}
                                  />
                                </div>
                              ))}
                            </Form>
                          </Col>
                          <Col sm={3} xs={7} className="fss-875 label-color">
                            <b>ONLY VIEW ACCESS </b>
                          </Col>
                          <Col sm={3} xs={5}>
                            <Form>
                              {["radio"].map((type) => (
                                <div
                                  key={`inline-${type}`}
                                  className={
                                    isMobile
                                      ? "mb-3 ps-0 pe-0 text-right"
                                      : "ms-4 mb-3"
                                  }
                                >
                                  <Form.Check
                                    className="custom-radio ps-0 pe-0 label-color fss-875"
                                    inline
                                    label="YES"
                                    name="onlyViewAccess"
                                    value="YES"
                                    type={type}
                                    checked={onlyViewAccess === true}
                                    onChange={() => setOnlyViewAccess(true)}
                                  />
                                  <Form.Check
                                    className="custom-radio label-color fss-875"
                                    inline
                                    label="NO"
                                    name="onlyViewAccess"
                                    value="NO"
                                    type={type}
                                    checked={onlyViewAccess === false}
                                    onChange={() => setOnlyViewAccess(false)}
                                  />
                                </div>
                              ))}
                            </Form>
                          </Col>
                        </Row>

                        <Row className="mt-0">
                          {selectedRole === "CUSTOMER" && (
                            <>
                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color"
                              >
                                <b>BAND SCRIPT ALLOW </b>
                              </Col>
                              <Col sm={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-3 ps-0 pe-0 text-right"
                                          : "ms-4 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio ps-0 pe-0 label-color fss-875"
                                        inline
                                        label="YES"
                                        name="bandScripAllow"
                                        value="YES"
                                        type={type}
                                        checked={bandScriptAllow === true}
                                        onChange={() =>
                                          setBandScriptAllow(true)
                                        }
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="NO"
                                        name="bandScripAllow"
                                        value="NO"
                                        type={type}
                                        checked={bandScriptAllow === false}
                                        onChange={() =>
                                          setBandScriptAllow(false)
                                        }
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>

                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color"
                              >
                                <b>M2M LINKED WITH LEDGER </b>
                              </Col>
                              <Col sm={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-1 ps-0 pe-0 text-right"
                                          : "ms-4 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio ps-0 pe-0 label-color fss-875"
                                        inline
                                        label="YES"
                                        name="m2mLinkedWithLedger"
                                        value="YES"
                                        type={type}
                                        checked={m2mLinkWithLedger === true}
                                        onChange={() =>
                                          setm2mLinkWithLedger(true)
                                        }
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="NO"
                                        name="m2mLinkedWithLedger"
                                        value="NO"
                                        type={type}
                                        checked={m2mLinkWithLedger === false}
                                        onChange={() =>
                                          setm2mLinkWithLedger(false)
                                        }
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                            </>
                          )}
                        </Row>

                        {selectedRole === "CUSTOMER" && (
                          <>
                            <Row className="mt-0">
                              <Col
                                sm={3}
                                xl={3}
                                xs={7}
                                className={
                                  isMobile
                                    ? "fss-875 label-color pt-1"
                                    : "fss-875 label-color"
                                }
                              >
                                <b>TRADE ALLOWED </b>
                              </Col>
                              <Col sm={3} xl={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mt-1 mb-3 ps-0 pe-0 text-right"
                                          : "ms-4 mb-1"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio ps-0 pe-0 label-color fss-875"
                                        inline
                                        label="YES"
                                        name="tradeAllowed"
                                        value="YES"
                                        type={type}
                                        checked={tradeAllowed === true}
                                        onChange={() => setTradeAllowed(true)}
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="NO"
                                        name="tradeAllowed"
                                        value="NO"
                                        type={type}
                                        checked={tradeAllowed === false}
                                        onChange={() => setTradeAllowed(false)}
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                              <Col
                                sm={3}
                                xl={3}
                                xs={6}
                                className="fss-875 label-color"
                              >
                                <b>ALERT (%) </b>
                              </Col>
                              <Col sm={2} xl={2} xs={6}>
                                <InputGroup size="sm">
                                  <Form.Control
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white custom-placeholder value-color"
                                    placeholder="ALERT(%)"
                                    type="number"
                                    name="alert"
                                    value={formData.alert}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        alert: e.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                              </Col>
                            </Row>
                          </>
                        )}
                        {selectedRole === "CUSTOMER" && (
                          <>
                            <Row className="pt-1">
                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color"
                              >
                                <b>ORDER LIMIT (%)</b>
                              </Col>
                              <Col sm={2} xs={6}>
                                <InputGroup size="sm">
                                  <Form.Control
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white  custom-placeholder  value-color "
                                    placeholder="OrderLimit(%)"
                                    name="orderLimit"
                                    type="number"
                                    value={formData.orderLimit}
                                    defaultValue={4}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        orderLimit: e.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                              </Col>
                              <Col sm={1}></Col>
                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color"
                              >
                                <b>SQ. OFF DISABLED IN (MINUTES) </b>
                              </Col>
                              <Col sm={2} xs={6} className="mt-1">
                                <InputGroup size="sm">
                                  <Form.Control
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white  value-color custom-placeholder"
                                    placeholder="0"
                                    type="number"
                                    name="squareOffDisabledInMin"
                                    value={formData.squareOffDisabledInMin}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        squareOffDisabledInMin: e.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                              </Col>

                              <Col sm={1}></Col>
                            </Row>

                            <Row className="mt-0">
                              <Col
                                sm={3}
                                xl={3}
                                xs={6}
                                className="fss-875 label-color mt-1"
                              >
                                <b>M2M LOSS </b>
                              </Col>
                              <Col
                                sm={2}
                                xl={2}
                                xs={6}
                                className={!isMobile ? "mt-0" : "mt-1"}
                              >
                                <InputGroup size="sm ">
                                  <Form.Control
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white  value-color custom-placeholder"
                                    placeholder="M2M LOSS"
                                    name="m2mLoss"
                                    type="number"
                                    value={formData.m2mLoss}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        m2mLoss: e.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                                {formData.m2mLoss ? (
                                  <label className="word-color">
                                    {" "}
                                    {NumberToWordFormatter.numberToWordsIndian(
                                      parseInt(formData.m2mLoss, 10)
                                    )}{" "}
                                  </label>
                                ) : (
                                  ""
                                )}
                              </Col>
                              <Col sm={1}></Col>
                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color mt-1"
                              >
                                <b>M2M PROFIT </b>
                              </Col>
                              <Col sm={2} xs={6} className="mt-1">
                                <InputGroup size="sm ">
                                  <Form.Control
                                    type="number"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white  value-color custom-placeholder"
                                    placeholder="M2M PROFIT"
                                    name="m2mProfit"
                                    value={formData.m2mProfit}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        m2mProfit: e.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                                {formData.m2mProfit ? (
                                  <label className="word-color">
                                    {" "}
                                    {NumberToWordFormatter.numberToWordsIndian(
                                      parseInt(formData.m2mProfit, 10)
                                    )}{" "}
                                  </label>
                                ) : (
                                  ""
                                )}
                              </Col>
                            </Row>
                          </>
                        )}
                        {selectedRole === "CUSTOMER" && (
                          <>
                            <Row className="mt-1">
                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color"
                              >
                                <b>TRADE BLOCK ABOVE </b>
                              </Col>
                              <Col sm={2} xs={6}>
                                <InputGroup size="sm">
                                  <Form.Control
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white  value-color custom-placeholder"
                                    placeholder="Trade Block Above"
                                    name="tradeBlockAbove"
                                    type="number"
                                    value={formData.tradeBlockAbove}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        tradeBlockAbove: e.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                                {formData.tradeBlockAbove ? (
                                  <label className="word-color">
                                    {" "}
                                    {NumberToWordFormatter.numberToWordsIndian(
                                      parseInt(formData.tradeBlockAbove, 10)
                                    )}{" "}
                                  </label>
                                ) : (
                                  ""
                                )}
                              </Col>
                              <Col sm={1}></Col>
                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color mt-1"
                              >
                                <b>TRADE BLOCK BELOW </b>
                              </Col>
                              <Col sm={2} xs={6} className="mt-1">
                                <InputGroup size="sm">
                                  <Form.Control
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white value-color custom-placeholder"
                                    placeholder="Trade Block Below"
                                    name="tradeBlockBelow"
                                    type="number"
                                    value={formData.tradeBlockBelow}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        tradeBlockBelow: e.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                                {formData.tradeBlockBelow ? (
                                  <label className="word-color">
                                    {" "}
                                    {NumberToWordFormatter.numberToWordsIndian(
                                      parseInt(formData.tradeBlockBelow, 10)
                                    )}{" "}
                                  </label>
                                ) : (
                                  ""
                                )}
                              </Col>
                            </Row>
                          </>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </>
            )}
            <div id="customerdetails">
              <Row className="mt-1">
                {selectedRole !== "SUBBROKER" && (
                  <>
                    <Col xs={12} xl={4}>
                      <Card>
                        <Card.Body className="pt-0">
                          <div>
                            <Row>
                              <lagend className="fieldset-legend-title label-color">
                                MARKET ACCESS
                              </lagend>
                            </Row>
                            <Row className="mt-1"></Row>
                            <Row>
                              {adminId.segments.includes("GLOBAL") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 1"
                                      type="checkbox"
                                      label="GLOBAL"
                                      className="custom-checkbox label-color fss-875"
                                      checked={isCheckedGlobal}
                                      onChange={handleCheckboxChange}
                                      name="index"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07 w-auto market-access"
                                      disabled={!isCheckedGlobal}
                                      onClick={handleOpenModal}
                                    >
                                      <b>
                                        GLOBAL <br /> Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null}

                              {adminId.segments.includes("NSE") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 2"
                                      type="checkbox"
                                      label="NSE"
                                      className="custom-checkbox label-color fss-875"
                                      checked={isCheckedNSE}
                                      onChange={handleCheckboxChange}
                                      name="nse"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07 w-auto market-access"
                                      disabled={!isCheckedNSE}
                                      onClick={handleOpenModalNSE}
                                    >
                                      <b>
                                        NSE <br />
                                        Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null}

                              {adminId.segments.includes("MCX") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 3"
                                      type="checkbox"
                                      label="MCX"
                                      className="custom-checkbox label-color fss-875 "
                                      checked={isCheckedMCX}
                                      onChange={handleCheckboxChange}
                                      name="mcx"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07 w-auto market-access"
                                      disabled={!isCheckedMCX}
                                      onClick={handleOpenModalMCX}
                                    >
                                      <b>
                                        MCX <br />
                                        Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null}

                             

                              <Modal
                                show={showModal}
                                onHide={handleCloseModal}
                                size="xl"
                              >
                                <Modal.Header>
                                  <Modal.Title className="modal-title-center">
                                    GLOBAL
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row className="mt-1">
                                    <Col xl={5} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          BROKERAGE DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingINDEXForBrokerageDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownINDEXForBrokerageDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          {selectedRole === "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile
                                                        ? "mt-3"
                                                        : "mt-3"
                                                    }`}
                                                  >
                                                    TYPE
                                                  </Form.Label>
                                                  {["radio"].map((type) => (
                                                    <div
                                                      key={`inline-${type}`}
                                                      style={{ marginTop: -10 }}
                                                    >
                                                      <Form.Check
                                                        inline
                                                        label="LOT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="group1"
                                                        type={type}
                                                        checked={
                                                          radioSelection ===
                                                          "LOT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelection(
                                                            "LOT"
                                                          )
                                                        }
                                                      />
                                                      <Form.Check
                                                        inline
                                                        label="PERCENT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="group1"
                                                        type={type}
                                                        checked={
                                                          radioSelection ===
                                                          "PERCENT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelection(
                                                            "PERCENT"
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                </Col>
                                              </Row>
                                              <div>
                                              {fieldsToRenderINDEX.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SELECT SCRIPT
                                                        </Form.Label>
                                                        <Select
                                                          options={
                                                            brokerageScripts
                                                          }
                                                          value={
                                                            brokerageScripts.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOption
                                                          ) =>
                                                            handleBrokerageScriptDropdown(
                                                              selectedOption,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          DELIVERY COM
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black text-nowrap"
                                                          placeholder="Delivery"
                                                          name="deliveryCom"
                                                          value={
                                                            inputField.deliveryCom
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetails(
                                                              e,
                                                              "deliveryCom",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              INTRADAY COM
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Intraday"
                                                              name="intradayCom"
                                                              value={
                                                                inputField.intradayCom
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetails(
                                                                  e,
                                                                  "intradayCom",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputFields.length >
                                                              1 &&
                                                              inputFields.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.id !==
                                                                    1 ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveField(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}
                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFields
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                {selectedBroker1 &&
                                                  selectedBroker1?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker1?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForINDEXBroker1.map(
                                                        (inputField) => (
                                                          <>
                                                            <Row
                                                              data-id={
                                                                inputField.id
                                                              }
                                                              className="mb-3"
                                                            >
                                                              <Col
                                                                xs={4}
                                                                className={`${
                                                                  isMobile
                                                                    ? "ps-1"
                                                                    : ""
                                                                }`}
                                                              >
                                                                <Form.Label
                                                                  className={`fss-875 label-color mb-1 text-nowrap ${
                                                                    !isMobile
                                                                      ? "mt-3"
                                                                      : "mt-3"
                                                                  }`}
                                                                >
                                                                  SELECT SCRIPT
                                                                </Form.Label>
                                                                <Select
                                                                  options={
                                                                    brokerageScripts
                                                                  }
                                                                  value={
                                                                    brokerageScripts.find(
                                                                      (
                                                                        script
                                                                      ) =>
                                                                        script.value ===
                                                                        inputField.selectedScript
                                                                    ) || null
                                                                  }
                                                                  onChange={(
                                                                    selectedOption
                                                                  ) =>
                                                                    handleBrokerageScriptDropdownForINDEXBroker1(
                                                                      selectedOption,
                                                                      inputField.id
                                                                    )
                                                                  }
                                                                  getOptionLabel={(
                                                                    e
                                                                  ) => e.label}
                                                                  placeholder={
                                                                    inputField.id ===
                                                                    1
                                                                      ? "All"
                                                                      : "Select"
                                                                  }
                                                                  isSearchable={
                                                                    false
                                                                  }
                                                                  className="fss-01 small-select text-black ps-0"
                                                                  theme={the}
                                                                  isDisabled={
                                                                    inputField.id ===
                                                                    1
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  styles={
                                                                    customStyles
                                                                  }
                                                                />
                                                              </Col>
                                                              <Col
                                                                xs={4}
                                                                className={`${
                                                                  isMobile
                                                                    ? "ps-1"
                                                                    : ""
                                                                }`}
                                                              >
                                                                <Form.Label
                                                                  className={`fss-875 label-color mb-1 text-nowrap ${
                                                                    !isMobile
                                                                      ? "mt-3"
                                                                      : "mt-3"
                                                                  }`}
                                                                >
                                                                  {" "}
                                                                  DELIVERY COM
                                                                </Form.Label>
                                                                <input
                                                                  type="number"
                                                                  className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                  placeholder="Delivery"
                                                                  name="deliveryCom"
                                                                  value={
                                                                    inputField.deliveryCom
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    inputChangeBrokerageDetailsINDEXForBroker1(
                                                                      e,
                                                                      "deliveryCom",
                                                                      inputField.id
                                                                    )
                                                                  }
                                                                />
                                                              </Col>
                                                              <Col
                                                                xs={4}
                                                                className={`${
                                                                  isMobile
                                                                    ? "ps-1"
                                                                    : ""
                                                                }`}
                                                              >
                                                                <Row>
                                                                  <Col xs={11}>
                                                                    <Form.Label
                                                                      className={`fss-875 label-color mb-1 text-nowrap ${
                                                                        !isMobile
                                                                          ? "mt-3"
                                                                          : "mt-3"
                                                                      }`}
                                                                    >
                                                                      {" "}
                                                                      INTRADAY
                                                                      COM
                                                                    </Form.Label>
                                                                  </Col>
                                                                </Row>
                                                                <Row>
                                                                  <Col
                                                                    xs={12}
                                                                    className="d-flex"
                                                                    style={{
                                                                      display:
                                                                        "inline-block",
                                                                    }}
                                                                  >
                                                                    <input
                                                                      type="number"
                                                                      className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                      placeholder="Intraday"
                                                                      name="intradayCom"
                                                                      value={
                                                                        inputField.intradayCom
                                                                      }
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        inputChangeBrokerageDetailsINDEXForBroker1(
                                                                          e,
                                                                          "intradayCom",
                                                                          inputField.id
                                                                        )
                                                                      }
                                                                    />

                                                                    {inputField.id ===
                                                                    1 ? (
                                                                      <Col
                                                                        sm={1}
                                                                        data-id={
                                                                          inputField.id
                                                                        }
                                                                        className="d-flex mt-3 justify-content-center align-items-center "
                                                                      >
                                                                        {" "}
                                                                      </Col>
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                    {inputFieldsForINDEXBroker1.map(
                                                                      (field) =>
                                                                        inputField.id ===
                                                                          field.id &&
                                                                        inputField.id !==
                                                                          1 ? (
                                                                          <span
                                                                            className="text-danger cursor-pointer"
                                                                            style={{
                                                                              fontSize:
                                                                                "20px",
                                                                              fontWeight:
                                                                                "800",
                                                                            }}
                                                                            onClick={() =>
                                                                              handleRemoveFieldForINDEXBroker1(
                                                                                inputField.id
                                                                              )
                                                                            }
                                                                          >
                                                                            ×
                                                                          </span>
                                                                        ) : null
                                                                    )}
                                                                  </Col>
                                                                </Row>
                                                              </Col>
                                                            </Row>
                                                          </>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForINDEXBroker1
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                                {selectedBroker2 &&
                                                  selectedBroker2?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker2?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForINDEXBroker2.map(
                                                        (inputField) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScripts
                                                                }
                                                                value={
                                                                  brokerageScripts.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForINDEXBroker2(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  inputField.id ===
                                                                  1
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  inputField.id ===
                                                                  1
                                                                    ? true
                                                                    : false
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsINDEXForBroker2(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsINDEXForBroker2(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />

                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForINDEXBroker2.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForINDEXBroker2(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForINDEXBroker2
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-2" : ""
                                                    }`}
                                                  >
                                                    MIN % WISE BROKERAGE PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black "
                                                    name="minPerBrokeragePerClientINDEX"
                                                    value={
                                                      minPerBrokeragePerClientINDEX
                                                    }
                                                    // onChange={handleInputChange}
                                                    onChange={(e) => {
                                                      setMinPerBrokeragePerClientINDEX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {minPerBrokeragePerClientINDEX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          minPerBrokeragePerClientINDEX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                            </>
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={3} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          MARGIN DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingINDEXForMarginDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownINDEXForMarginDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="LOT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group3"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelection ===
                                                      "LOT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelection(
                                                        "LOT"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="AMOUNT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group3"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelection ===
                                                      "AMOUNT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelection(
                                                        "AMOUNT"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {marginDetailsRadioSelection ===
                                            "LOT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL LOT WISE(DELIVERY)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryINDEX"
                                                  value={marginDetailsINDEXLot}
                                                  // onChange={handleInputChange}
                                                  onChange={(e) => {
                                                    setMarginDetailsINEDXLot(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsINDEXLot ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsINDEXLot,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                          {marginDetailsRadioSelection ===
                                            "AMOUNT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL AMOUNT WISE(MARGIN)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black"
                                                  name="marginDetailsDeliveryINDEX"
                                                  value={
                                                    marginDetailsINDEXAmount
                                                  }
                                                  // onChange={handleInputChange}
                                                  onChange={(e) => {
                                                    setMarginDetailsINDEXAmount(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsINDEXAmount ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsINDEXAmount,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}

                                          {selectedRole !== "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MAXIMUM MARGIN LIMIT PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black text-nowrap "
                                                    name="maxMarginPerClientINDEX"
                                                    value={
                                                      maxMarginPerClientINDEX
                                                    }
                                                    onChange={(e) => {
                                                      setMaxMarginPerClientINDEX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {maxMarginPerClientINDEX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          maxMarginPerClientINDEX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={4} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          OTHER DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingINDEXForOtherDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownINDEXForOtherDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="ALLOW"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group2"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsIndexRadioSelection ===
                                                      "ALLOW"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsIndexRadioSelection(
                                                        "ALLOW"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="BLOCK"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group2"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsIndexRadioSelection ===
                                                      "BLOCK"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsIndexRadioSelection(
                                                        "BLOCK"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {scriptDetailsIndexRadioSelection ===
                                            "ALLOW" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  ALLOW SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={scriptDetailsScript}
                                                  value={scriptDetailsScript.filter(
                                                    (scriptDeatails) =>
                                                      scriptDeatailsDropdownIndex.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleScriptDetailsDropdownINDEX
                                                  } // Handle changes to selection
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti // Allow multiple selections
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {scriptDetailsIndexRadioSelection ===
                                            "BLOCK" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  BLOCK SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={blockedScriptDetails}
                                                  value={blockedScriptDetails.filter(
                                                    (scriptDeatails) =>
                                                      blockedScriptDropdownIndex.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleBlockedScriptDropdownIndex
                                                  } // Handle changes to selection
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti // Allow multiple selections
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          <Row className="">
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                HOW MANY SCRIPTS TO WORK IN
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                size="sm"
                                                className="fss-875 bg-white text-black "
                                                name="howManyScriptToWorkIn"
                                                value={indexScriptToWork}
                                                onChange={(e) => {
                                                  setIndexScriptToWork(
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <Form.Check
                                                aria-label="option 1"
                                                type="checkbox"
                                                label="FRESH LIMIT ALLOWED?"
                                                className="custom-checkbox label-color fss-875 mt-3"
                                                checked={indexFreshLimitAllowed}
                                                onChange={(e) => {
                                                  setIndexFreshLimitAllowed(
                                                    e.target.checked
                                                  );
                                                }}
                                                name="index"
                                              />
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                  </Row>

                                     {selectedRole === "111" ? (
                                    <> 
                                      <Row className="mt-1">
                                          <Col
                                            xl={12}
                                            className={`${
                                              !isMobile ? "ps-0 pe-1" : "ps-0 pe-1"
                                            }`}
                                          >
                                            <Card>
                                              <Card.Header className="fieldset-legend-title label-color mb-1">
                                                QUANTITY SETTINGS
                                              </Card.Header>
                                              <Card.Body>
                                                <Row>
                                                  <Col xl={3}>
                                                    <Form.Label
                                                      className={`fss-875 label-color mb-1 ${
                                                        !isMobile ? "mt-0" : ""
                                                      }`}
                                                    >
                                                      COPY SETTINGS
                                                    </Form.Label>
                                                    <Select
                                                      options={copySettingOptions.map(
                                                        (item) => ({
                                                          value: item?.user?.userid,
                                                          label: `(${item?.user?.userName}) ${item?.user?.firstName}`
                                                        })
                                                      )}
                                                      value={
                                                        copySettingGLOBALForQuantitySettings
                                                      } // Filter selected values
                                                      onChange={
                                                        handleCopySettingDropdownGLOBALForQuantitySettings
                                                      } // Handle changes to selection
                                                      getOptionLabel={(e) => e.label}
                                                      placeholder="SELECT"
                                                      isSearchable={true}
                                                      isClearable={true}
                                                      className="fss-01 small-select text-black"
                                                      theme={the}
                                                      styles={customStyles}
                                                    />
                                                  </Col>
                                                </Row>

                                                  <div>
                                                    {fieldsToRenderQtySettingsGLOBAL.map(
                                                        (inputField, index) => (
                                                          <Row
                                                            data-id={inputField.id}
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              xl={4}
                                                              className={`${
                                                                isMobile ? "ps-1" : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SCRIPT
                                                              </Form.Label>

                                                              <Select
                                                                options={
                                                                  brokerageScripts
                                                                }
                                                                value={
                                                                  brokerageScripts.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.script
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleQtySettingScriptDropdownGLOBAL(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(e) =>
                                                                  e.label
                                                                }
                                                                placeholder={
                                                                  index === 0
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={true}
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  index === 0
                                                                }
                                                                styles={modelDropdown}
                                                              />

                                                            </Col>  
                                                            <Col
                                                              xs={2}
                                                              xl={2}
                                                              className={`${
                                                                isMobile ? "ps-1" : "ps-0"
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                MIN
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Min"
                                                                name="minOrder"
                                                                value={
                                                                  inputField.minOrder
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeQtySettingsGLOBAL(
                                                                    e,
                                                                    "minOrder",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>

                                                            <Col
                                                              xs={3}
                                                              xl={3}
                                                              className={`${
                                                                isMobile ? "ps-1" : "ps-0"
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                MAX
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Max"
                                                                name="maxOrder"
                                                                value={
                                                                  inputField.maxOrder
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeQtySettingsGLOBAL(
                                                                    e,
                                                                    "maxOrder",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>

                                                            <Col
                                                              xs={3}
                                                              xl={3}
                                                              className={`${
                                                                isMobile ? "ps-1" : "ps-0"
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    POSITION
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Position"
                                                                    name="positionLimit"
                                                                    value={
                                                                      inputField.positionLimit
                                                                    }
                                                                    onChange={(e) =>
                                                                      inputChangeQtySettingsGLOBAL(
                                                                        e,
                                                                        "positionLimit",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />

                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                    {fieldsToRenderQtySettingsGLOBAL.length >
                                                                    1 &&
                                                                    fieldsToRenderQtySettingsGLOBAL.map(
                                                                      (
                                                                        field,
                                                                        index
                                                                      ) =>
                                                                        inputField.id ===
                                                                          field.id &&
                                                                        inputField.script !==
                                                                          "ALL" ? (
                                                                          index !==
                                                                          0 ? (
                                                                            <span
                                                                              className="text-danger cursor-pointer"
                                                                              style={{
                                                                                fontSize:
                                                                                  "20px",
                                                                                fontWeight:
                                                                                  "800",
                                                                              }}
                                                                              onClick={() =>
                                                                                handleRemoveFieldQtyGLOBAL(
                                                                                  inputField.id
                                                                                )
                                                                              }
                                                                            >
                                                                              ×
                                                                            </span>
                                                                          ) : null
                                                                        ) : null
                                                                    )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsGLOBALQtySettings
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </div>

                                            </Card.Body>
                                          </Card>
                                        </Col>
                                      </Row>    
                                      </>) : (
                                    <>
                                  </>)}

                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="danger"
                                    onClick={handleCloseModal}
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                              <Modal
                                show={showModalMCX}
                                onHide={handleCloseModalMCX}
                                size="xl"
                              >
                                <Modal.Header>
                                  <Modal.Title className="modal-title-center">
                                    MCX
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row className="mt-1">
                                    <Col
                                      xl={5}
                                      className={`${
                                        !isMobile ? "ps-0 pe-1" : "ps-0 pe-1"
                                      }`}
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          BROKERAGE DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForBrokerageDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXorBrokerageDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>

                                          {selectedRole === "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile
                                                        ? "mt-3"
                                                        : "mt-3"
                                                    }`}
                                                  >
                                                    TYPE
                                                  </Form.Label>
                                                  {["radio"].map((type) => (
                                                    <div
                                                      key={`inline-${type}`}
                                                      style={{ marginTop: -5 }}
                                                    >
                                                      <Form.Check
                                                        inline
                                                        label="LOT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="MCX3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionMCX ===
                                                          "LOT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionMCX(
                                                            "LOT"
                                                          )
                                                        }
                                                      />
                                                      <Form.Check
                                                        inline
                                                        label="PERCENT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="MCX3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionMCX ===
                                                          "PERCENT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionMCX(
                                                            "PERCENT"
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                </Col>
                                              </Row>

                                            <div>
                                              {fieldsToRenderMCX.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SELECT SCRIPT
                                                        </Form.Label>
                                                        <Select
                                                          options={
                                                            brokerageScriptsMCX
                                                          }
                                                          value={
                                                            brokerageScriptsMCX.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOptionMCX
                                                          ) =>
                                                            handleBrokerageScriptDropdownMCX(
                                                              selectedOptionMCX,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          DELIVERY COM
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Delivery"
                                                          name="deliveryCom"
                                                          value={
                                                            inputField.deliveryCom
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetailsMCX(
                                                              e,
                                                              "deliveryCom",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              INTRADAY COM
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Intraday"
                                                              name="intradayCom"
                                                              value={
                                                                inputField.intradayCom
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetailsMCX(
                                                                  e,
                                                                  "intradayCom",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputField.id ===
                                                            1 ? (
                                                              <Col
                                                                sm={1}
                                                                data-id={
                                                                  inputField.id
                                                                }
                                                                className="d-flex mt-3 justify-content-center align-items-center "
                                                              >
                                                                {" "}
                                                              </Col>
                                                            ) : (
                                                              ""
                                                            )}
                                                              {inputFieldsMCX.length >
                                                              1 &&
                                                              inputFieldsMCX.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.id !==
                                                                    1 ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveFieldMCX(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}
                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFieldsMCX
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                {selectedBroker1 &&
                                                  selectedBroker1?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker1?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForMCXBroker1.map(
                                                        (inputField) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScriptsMCX
                                                                }
                                                                value={
                                                                  brokerageScriptsMCX.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForMCXBroker1(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  inputField.id ===
                                                                  1
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  inputField.id ===
                                                                  1
                                                                    ? true
                                                                    : false
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsMCXForBroker1(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsMCXForBroker1(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />

                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForMCXBroker1.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForMCXBroker1(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForMCXBroker1
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                                {selectedBroker2 &&
                                                  selectedBroker2?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker2?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForMCXBroker2.map(
                                                        (inputField) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScriptsMCX
                                                                }
                                                                value={
                                                                  brokerageScriptsMCX.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForMCXBroker2(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  inputField.id ===
                                                                  1
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  inputField.id ===
                                                                  1
                                                                    ? true
                                                                    : false
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsMCXForBroker2(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsMCXForBroker2(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />

                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForMCXBroker2.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForMCXBroker2(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForMCXBroker2
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                              </div>

                                           

                                            </>
                                          ) : (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MIN % WISE BROKERAGE PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black "
                                                    name="minPerBrokeragePerClientMCX"
                                                    value={
                                                      minPerBrokeragePerClientMCX
                                                    }
                                                    // onChange={handleInputChange}
                                                    onChange={(e) => {
                                                      setMinPerBrokeragePerClientMCX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {minPerBrokeragePerClientMCX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          minPerBrokeragePerClientMCX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>

                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MIN LOT WISE BROKERAGE
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black "
                                                    name="minLotBrokeragePerClientMCX"
                                                    value={
                                                      minLotBrokeragePerClientMCX
                                                    }
                                                    onChange={(e) => {
                                                      setMinLotBrokeragePerClientMCX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {minLotBrokeragePerClientMCX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          minLotBrokeragePerClientMCX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                              <div>
                                                {fieldsToRenderMCXRatherThanCustomerType.map(
                                                  (inputField) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mt-3 p-2"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Select
                                                          options={
                                                            brokerageScriptsMCX
                                                          }
                                                          value={
                                                            brokerageScriptsMCX.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOptionMCX
                                                          ) =>
                                                            handleBrokerageScriptDropdownMCXRatherThanCustomerType(
                                                              selectedOptionMCX,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder="Select"
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black text-nowrap"
                                                          placeholder="%"
                                                          name="mcxPercentage"
                                                          value={
                                                            inputField.mcxPercentage
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetailsForMCXRatherThanCustomerType(
                                                              e,
                                                              "mcxPercentage",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row></Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Lot"
                                                              name="mcxLot"
                                                              value={
                                                                inputField.mcxLot
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetailsForMCXRatherThanCustomerType(
                                                                  e,
                                                                  "mcxLot",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            <span
                                                              className="text-danger cursor-pointer"
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                                fontWeight:
                                                                  "800",
                                                              }}
                                                              onClick={() =>
                                                                handleRemoveFieldMCXRatherThanCustomerType(
                                                                  inputField.id
                                                                )
                                                              }
                                                            >
                                                              ×
                                                            </span>
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}
                                              </div>
                                              <Row className="mt-1">
                                                <Col>
                                                  <div className="text-end mt-3">
                                                    <Button
                                                      variant="success"
                                                      size="sm"
                                                      className="mt-1"
                                                      onClick={
                                                        handleAddFieldsMCXRatherThanCustomerType
                                                      }
                                                    >
                                                      + Add
                                                    </Button>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </>
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col
                                      xl={3}
                                      className={
                                        isMobile
                                          ? "ps-0 pe-1 mt-2"
                                          : "ps-0 pe-1"
                                      }
                                      xs={isMobile ? 12 : 0}
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          MARGIN DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForMarginDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXForMarginDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div
                                                  key={`inline-${type}`}
                                                  style={{ marginTop: 5 }}
                                                >
                                                  <Form.Check
                                                    inline
                                                    label="LOT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionMCX ===
                                                      "LOT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionMCX(
                                                        "LOT"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="AMOUNT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionMCX ===
                                                      "AMOUNT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionMCX(
                                                        "AMOUNT"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {marginDetailsRadioSelectionMCX ===
                                            "LOT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL LOT WISE(DELIVERY)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryMCX"
                                                  value={marginDetailsMCXLot}
                                                  onChange={(e) => {
                                                    setMarginDetailsMCXLot(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsMCXLot ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsMCXLot,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                          {marginDetailsRadioSelectionMCX ===
                                            "AMOUNT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL AMOUNT WISE(MARGIN)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryMCX"
                                                  value={marginDetailsMCXAmount}
                                                  // onChange={handleInputChangeMCX}
                                                  onChange={(e) => {
                                                    setMarginDetailsMCXAmount(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsMCXAmount ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsMCXAmount,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}

                                          {selectedRole !== "CUSTOMER" ? (
                                            <>
                                              {marginDetailsRadioSelectionMCX ===
                                            "LOT" && (
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MAXIMUM LOT LIMIT PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black text-nowrap "
                                                    name="maxLotPerClientMCX"
                                                    value={
                                                      maxLotPerClientMCX
                                                    }
                                                    onChange={(e) => {
                                                      setMaxLotPerClientMCX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {maxLotPerClientMCX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          maxLotPerClientMCX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                            )}
                                              {marginDetailsRadioSelectionMCX ===
                                            "AMOUNT" && (
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MAXIMUM MARGIN LIMIT PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black text-nowrap "
                                                    name="maxMarginPerClientMCX"
                                                    value={
                                                      maxMarginPerClientMCX
                                                    }
                                                    onChange={(e) => {
                                                      setMaxMarginPerClientMCX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {maxMarginPerClientMCX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          maxMarginPerClientMCX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                            )}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col
                                      xl={4}
                                      className={
                                        isMobile
                                          ? "ps-0 pe-1 mt-2"
                                          : "ps-0 pe-1"
                                      }
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          OTHER DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForOtherDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXForOtherDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div
                                                  key={`inline-${type}`}
                                                  style={{ marginTop: 5 }}
                                                >
                                                  <Form.Check
                                                    inline
                                                    label="ALLOW"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionMCX ===
                                                      "ALLOW"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionMCX(
                                                        "ALLOW"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="BLOCK"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionMCX ===
                                                      "BLOCK"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionMCX(
                                                        "BLOCK"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {scriptDetailsRadioSelectionMCX ===
                                            "ALLOW" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  ALLOW SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    scriptDetailsScriptMCX
                                                  }
                                                  value={scriptDetailsScriptMCX.filter(
                                                    (scriptDeatails) =>
                                                      scriptDeatailsDropdownMCX.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter the selected values
                                                  onChange={
                                                    handleScriptDetailsDropdownMCX
                                                  } // Handle changes to selection
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti // Allow multiple selections
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {scriptDetailsRadioSelectionMCX ===
                                            "BLOCK" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  BLOCK SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    blockedScriptDetailsMCX
                                                  }
                                                  value={blockedScriptDetailsMCX.filter(
                                                    (scriptDeatails) =>
                                                      blockedScriptDropdownMCX.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleBlockedScriptDropdownMCX
                                                  } // Handle selection change
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          <Row className="">
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                HOW MANY SCRIPTS TO WORK IN
                                              </Form.Label>

                                              <Form.Control
                                                type="number"
                                                size="sm"
                                                className="fss-875 bg-white text-black "
                                                name="howManyScriptToWorkIn"
                                                value={mcxScriptToWork}
                                                onChange={(e) => {
                                                  setMCXScriptToWork(
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <Form.Check
                                                aria-label="option 1"
                                                type="checkbox"
                                                label="FRESH LIMIT ALLOWED?"
                                                className="custom-checkbox label-color fss-875 mt-3"
                                                checked={mcxFreshLimitAllowed}
                                                onChange={(e) => {
                                                  setMcxFreshLimitAllowed(
                                                    e.target.checked
                                                  );
                                                }}
                                                name="index"
                                              />
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                  </Row>


                                {selectedRole === "111" ? (
                                  <> 
                                 <Row className="mt-1">
                                    <Col
                                      xl={12}
                                      className={`${
                                        !isMobile ? "ps-0 pe-1" : "ps-0 pe-1"
                                      }`}
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          LOT/QUANTITY SETTINGS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col xl={3}>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-0" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForQuantitySettings
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXForQuantitySettings
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT"
                                                isSearchable={true}
                                                isClearable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>

                                            <div>
                                              {fieldsToRenderQtySettingsMCX.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        xl={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SCRIPT
                                                        </Form.Label>

                                                        <Select
                                                          options={
                                                            brokerageScriptsMCX
                                                          }
                                                          value={
                                                            brokerageScriptsMCX.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.script
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOption
                                                          ) =>
                                                            handleQtySettingScriptDropdownMCX(
                                                              selectedOption,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={true}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={modelDropdown}
                                                        />

                                                      </Col>  
                                                      <Col
                                                        xs={2}
                                                        xl={2}
                                                        className={`${
                                                          isMobile ? "ps-1" : "ps-0"
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          MIN
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Min"
                                                          name="minOrder"
                                                          value={
                                                            inputField.minOrder
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeQtySettingsMCX(
                                                              e,
                                                              "minOrder",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>

                                                       <Col
                                                        xs={3}
                                                        xl={3}
                                                        className={`${
                                                          isMobile ? "ps-1" : "ps-0"
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          MAX
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Max"
                                                          name="maxOrder"
                                                          value={
                                                            inputField.maxOrder
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeQtySettingsMCX(
                                                              e,
                                                              "maxOrder",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>

                                                      <Col
                                                        xs={3}
                                                        xl={3}
                                                        className={`${
                                                          isMobile ? "ps-1" : "ps-0"
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              POSITION
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Position"
                                                              name="positionLimit"
                                                              value={
                                                                inputField.positionLimit
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeQtySettingsMCX(
                                                                  e,
                                                                  "positionLimit",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputField.id ===
                                                            1 ? (
                                                              <Col
                                                                sm={1}
                                                                data-id={
                                                                  inputField.id
                                                                }
                                                                className="d-flex mt-3 justify-content-center align-items-center "
                                                              >
                                                                {" "}
                                                              </Col>
                                                            ) : (
                                                              ""
                                                            )}
                                                              {fieldsToRenderQtySettingsMCX.length >
                                                              1 &&
                                                              fieldsToRenderQtySettingsMCX.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.script !==
                                                                    "ALL" ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveFieldQtyMCX(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}
                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFieldsMCXQtySettings
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                      </Card.Body>
                                    </Card>
                                  </Col>
                                </Row>    
                                </>) : (
                              <>
                                </>)}

                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="danger"
                                    onClick={handleCloseModalMCX}
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                              <Modal
                                show={showModalNSE}
                                onHide={handleCloseModalNSE}
                                size="xl"
                              >
                                <Modal.Header>
                                  <Modal.Title className="modal-title-center">
                                    NSE
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row className="mt-1">
                                    <Col xl={5} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          BROKERAGE DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForBrokerageDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForBrokerageDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          {selectedRole === "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile
                                                        ? "mt-3"
                                                        : "mt-3"
                                                    }`}
                                                  >
                                                    TYPE
                                                  </Form.Label>
                                                  {["radio"].map((type) => (
                                                    <div
                                                      key={`inline-${type}`}
                                                      style={{ marginTop: -10 }}
                                                    >
                                                      <Form.Check
                                                        inline
                                                        label="LOT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="NSE3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionNSE ===
                                                          "LOT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionNSE(
                                                            "LOT"
                                                          )
                                                        }
                                                      />
                                                      <Form.Check
                                                        inline
                                                        label="PERCENT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="NSE3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionNSE ===
                                                          "PERCENT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionNSE(
                                                            "PERCENT"
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                </Col>
                                              </Row>
                                              <div>
                                              {fieldsToRender.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SELECT SCRIPT
                                                        </Form.Label>
                                                        <Select
                                                          options={
                                                            brokerageScriptsNSE
                                                          }
                                                          value={
                                                            brokerageScriptsNSE.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOptionNSE
                                                          ) =>
                                                            handleBrokerageScriptDropdownNSE(
                                                              selectedOptionNSE,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          // isDisabled={
                                                          //   inputField.id === 1
                                                          //     ? true
                                                          //     : false
                                                          // }
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          DELIVERY COM
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Delivery"
                                                          name="deliveryCom"
                                                          value={
                                                            inputField.deliveryCom
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetailsNSE(
                                                              e,
                                                              "deliveryCom",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              INTRADAY COM
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Intraday"
                                                              name="intradayCom"
                                                              value={
                                                                inputField.intradayCom
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetailsNSE(
                                                                  e,
                                                                  "intradayCom",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputField.id ===
                                                            1 ? (
                                                              <Col
                                                                sm={1}
                                                                data-id={
                                                                  inputField.id
                                                                }
                                                                className="d-flex mt-3 justify-content-center align-items-center "
                                                              >
                                                                {" "}
                                                              </Col>
                                                            ) : (
                                                              ""
                                                            )}

                                                            {/* {inputFieldsNSE.map(
                                                              (field) =>
                                                                inputField.id ===
                                                                  field.id &&
                                                                inputField.id !==
                                                                  1 ? (
                                                                  <span
                                                                    className="text-danger cursor-pointer"
                                                                    style={{
                                                                      fontSize:
                                                                        "20px",
                                                                      fontWeight:
                                                                        "800",
                                                                    }}
                                                                    onClick={() =>
                                                                      handleRemoveFieldNSE(
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  >
                                                                    ×
                                                                  </span>
                                                                ) : null
                                                            )} */}
                                                              {inputFieldsNSE.length >
                                                              1 &&
                                                              inputFieldsNSE.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.id !==
                                                                    1 ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveFieldNSE(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}


                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFieldsNSE
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                {selectedBroker1 &&
                                                  selectedBroker1?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker1?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForNSEBroker1.map(
                                                        (inputField) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScriptsNSE
                                                                }
                                                                value={
                                                                  brokerageScriptsNSE.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForNSEBroker1(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  inputField.id ===
                                                                  1
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  inputField.id ===
                                                                  1
                                                                    ? true
                                                                    : false
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsNSEForBroker1(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsNSEForBroker1(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />
                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForNSEBroker1.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForNSEBroker1(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForNSEBroker1
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                                {selectedBroker2 &&
                                                  selectedBroker2?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker2?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForNSEBroker2.map(
                                                        (inputField) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScriptsNSE
                                                                }
                                                                value={
                                                                  brokerageScriptsNSE.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForNSEBroker2(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  inputField.id ===
                                                                  1
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  inputField.id ===
                                                                  1
                                                                    ? true
                                                                    : false
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsNSEForBroker2(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsNSEForBroker2(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />

                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForNSEBroker2.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForNSEBroker2(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForNSEBroker2
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MIN % WISE BROKERAGE PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black "
                                                    name="minPerBrokeragePerClientNSE"
                                                    value={
                                                      minPerBrokeragePerClientNSE
                                                    }
                                                    // onChange={handleInputChange}
                                                    onChange={(e) => {
                                                      setMinPerBrokeragePerClientNSE(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {minPerBrokeragePerClientNSE ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          minPerBrokeragePerClientNSE,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                              {/* <div>
                                            {fieldsToRenderNSERatherThanCustomerType.map(
                                              (inputField) => (
                                                <Row
                                                  data-id={inputField.id}
                                                  className="mt-3 p-2"
                                                >
                                                  <Col
                                                    xs={4}
                                                    className={`${
                                                      isMobile ? "ps-1" : ""
                                                    }`}
                                                  >
                                                     <Select
                                                     options={
                                                      brokerageScriptsNSE
                                                    }
                                                    value={
                                                      brokerageScriptsNSE.find(
                                                        (script) =>
                                                          script.value ===
                                                          inputField.selectedScript
                                                      ) || null
                                                    }
                                                    onChange={(
                                                      selectedOptionNSE
                                                    ) =>
                                                      handleBrokerageScriptDropdownNSERatherThanCustomerType(
                                                        selectedOptionNSE,
                                                        inputField.id
                                                      )
                                                    }
                                                    getOptionLabel={(e) =>
                                                      e.label
                                                    }
                                                      placeholder="Select"
                                                      isSearchable={false}
                                                      className="fss-01 small-select text-black ps-0"
                                                      theme={the}
                                                      styles={customStyles}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={4}
                                                    className={`${
                                                      isMobile ? "ps-1" : ""
                                                    }`}
                                                  >
                                                    <input
                                                      type="number"
                                                      className="form-control bg-light form-control-md fss-875 custom-placeholder text-black text-nowrap"
                                                      placeholder="%"
                                                      name="nsePercentage"
                                                      value={
                                                        inputField.nsePercentage
                                                      }
                                                      onChange={(e) =>
                                                        inputChangeBrokerageDetailsForNSERatherThanCustomerType(
                                                          e,
                                                          "nsePercentage",
                                                          inputField.id
                                                        )
                                                      }
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={4}
                                                    className={`${
                                                      isMobile ? "ps-1" : ""
                                                    }`}
                                                  >
                                                    <Row>
                                                      
                                                    </Row>
                                                    <Row>
                                                      <Col
                                                        xs={12}
                                                        className="d-flex"
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                        }}
                                                      >
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Lot"
                                                          name="nseLot"
                                                          value={
                                                            inputField.nseLot
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetailsForNSERatherThanCustomerType(
                                                              e,
                                                              "nseLot",
                                                              inputField.id
                                                            )
                                                          }
                                                        />

                                                              <span
                                                               className="text-danger cursor-pointer"
                                                                style={{
                                                                  fontSize:
                                                                    "20px",
                                                                  fontWeight:
                                                                    "800",
                                                                }}
                                                                onClick={() =>
                                                                  handleRemoveFieldNSERatherThanCustomerType(
                                                                    inputField.id
                                                                  )
                                                                }
                                                              >
                                                                ×
                                                              </span>
                                                           
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                </Row>
                                              )
                                            )}
                                               <Row className="mt-1">
                                              <Col>
                                                <div className="text-end mt-3">
                                                  <Button
                                                    variant="success"
                                                    size="sm"
                                                    className="mt-1"
                                                    onClick={handleAddFieldsNSERatherThanCustomerType}
                                                  >
                                                    + Add
                                                  </Button>
                                                </div>
                                              </Col>
                                            </Row>
                                            </div> */}
                                            </>
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={3} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          MARGIN DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForMarginDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForMarginDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="LOT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionNSE ===
                                                      "LOT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionNSE(
                                                        "LOT"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="AMOUNT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionNSE ===
                                                      "AMOUNT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionNSE(
                                                        "AMOUNT"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {marginDetailsRadioSelectionNSE ===
                                            "LOT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL LOT WISE(DELIVERY)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryNSE"
                                                  value={marginDetailsNSELot}
                                                  onChange={(e) => {
                                                    setMarginDetailsNSELot(
                                                      e.target.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsNSELot ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsNSELot,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                          {marginDetailsRadioSelectionNSE ===
                                            "AMOUNT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL AMOUNT WISE(MARGIN)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryNSE"
                                                  value={marginDetailsNSEAmount}
                                                  // onChange={handleInputChangeNSE}
                                                  onChange={(e) => {
                                                    setMarginDetailsNSEAmount(
                                                      e.target.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsNSEAmount ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsNSEAmount,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}

                                          {selectedRole !== "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MAXIMUM MARGIN LIMIT PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black text-nowrap "
                                                    name="maxMarginPerClientNSE"
                                                    value={
                                                      maxMarginPerClientNSE
                                                    }
                                                    onChange={(e) => {
                                                      setMaxMarginPerClientNSE(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {maxMarginPerClientNSE ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          maxMarginPerClientNSE,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={4} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          OTHER DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForOtherDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForOtherDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="ALLOW"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionNSE ===
                                                      "ALLOW"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionNSE(
                                                        "ALLOW"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="BLOCK"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionNSE ===
                                                      "BLOCK"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionNSE(
                                                        "BLOCK"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {scriptDetailsRadioSelectionNSE ===
                                            "ALLOW" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  ALLOW SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    scriptDetailsScriptNSE
                                                  }
                                                  value={scriptDetailsScriptNSE?.filter(
                                                    (scriptDeatails) =>
                                                      scriptDeatailsDropdownNSE.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter based on the selected values
                                                  onChange={
                                                    handleScriptDetailsDropdownNSE
                                                  } // Handle change
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {scriptDetailsRadioSelectionNSE ===
                                            "BLOCK" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  BLOCK SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    blockedScriptDetailsNSE
                                                  }
                                                  value={blockedScriptDetailsNSE?.filter(
                                                    (scriptDeatails) =>
                                                      blockedScriptDropdownNSE.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleBlockedScriptDropdownNSE
                                                  } // Handle changes
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          <Row className="">
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                HOW MANY SCRIPTS TO WORK IN
                                              </Form.Label>

                                              <Form.Control
                                                type="number"
                                                size="sm"
                                                className="fss-875 bg-white text-black "
                                                name="howManyScriptToWorkIn"
                                                value={NseScriptToWork}
                                                onChange={(e) => {
                                                  setNSEScriptToWork(
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <Form.Check
                                                aria-label="option 1"
                                                type="checkbox"
                                                label="FRESH LIMIT ALLOWED?"
                                                className="custom-checkbox label-color fss-875 mt-3"
                                                checked={nseFreshLimitAllowed}
                                                onChange={(e) => {
                                                  setNseFreshLimitAllowed(
                                                    e.target.checked
                                                  );
                                                }}
                                                name="index"
                                              />
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                  </Row>

                                   {selectedRole === "111" ? (
                                  <> 
                                 <Row className="mt-1">
                                    <Col
                                      xl={12}
                                      className={`${
                                        !isMobile ? "ps-0 pe-1" : "ps-0 pe-1"
                                      }`}
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          QUANTITY SETTINGS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col xl={3}>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-0" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForQuantitySettings
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForQuantitySettings
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT"
                                                isSearchable={true}
                                                isClearable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>

                                            <div>
                                              {fieldsToRenderQtySettingsNSE.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        xl={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SCRIPT
                                                        </Form.Label>

                                                        <Select
                                                          options={
                                                            brokerageScriptsNSE
                                                          }
                                                          value={
                                                            brokerageScriptsNSE.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.script
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOption
                                                          ) =>
                                                            handleQtySettingScriptDropdownNSE(
                                                              selectedOption,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                           isSearchable={true}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={modelDropdown}
                                                        />

                                                      </Col>  
                                                      <Col
                                                        xs={2}
                                                        xl={2}
                                                        className={`${
                                                          isMobile ? "ps-1" : "ps-0"
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          MIN
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Min"
                                                          name="minOrder"
                                                          value={
                                                            inputField.minOrder
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeQtySettingsNSE(
                                                              e,
                                                              "minOrder",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>

                                                       <Col
                                                        xs={3}
                                                        xl={3}
                                                        className={`${
                                                          isMobile ? "ps-1" : "ps-0"
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          MAX
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Max"
                                                          name="maxOrder"
                                                          value={
                                                            inputField.maxOrder
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeQtySettingsNSE(
                                                              e,
                                                              "maxOrder",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>

                                                      <Col
                                                        xs={3}
                                                        xl={3}
                                                        className={`${
                                                          isMobile ? "ps-1" : "ps-0"
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              POSITION
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Position"
                                                              name="positionLimit"
                                                              value={
                                                                inputField.positionLimit
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeQtySettingsNSE(
                                                                  e,
                                                                  "positionLimit",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputField.id ===
                                                            1 ? (
                                                              <Col
                                                                sm={1}
                                                                data-id={
                                                                  inputField.id
                                                                }
                                                                className="d-flex mt-3 justify-content-center align-items-center "
                                                              >
                                                                {" "}
                                                              </Col>
                                                            ) : (
                                                              ""
                                                            )}
                                                              {fieldsToRenderQtySettingsNSE.length >
                                                              1 &&
                                                              fieldsToRenderQtySettingsNSE.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.script !==
                                                                    "ALL" ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveFieldQtyNSE(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}
                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFieldsNSEQtySettings
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                      </Card.Body>
                                    </Card>
                                  </Col>
                                </Row>    
                                </>) : (
                              <>
                                </>)}

                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="danger"
                                    onClick={handleCloseModalNSE}
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            </Row>
                            <Row>
                              <Col></Col>
                              <Col></Col>
                              <Col></Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </>
                )}
                {selectedRole === "CUSTOMER" && (
                  <>
                    <Col xs={12} xl={4} className="mt-1">
                      <Card className={isMobile ? "me-0" : "me-2"}>
                        <Card.Body className="pt-0">
                          <div>
                            <Row>
                              <lagend className="fieldset-legend-title label-color">
                                BROKER INFO
                              </lagend>
                            </Row>
                            <Row className="mt-1">
                              <Col sm={6}>
                                <b className="fss-875 label-color">BROKER 1</b>
                                <Select
                                  options={subBroker.map((item) => ({
                                    value: item.adminId,
                                    label: `${item.firstName} (${item.userName})`,
                                  }))}
                                  onChange={handleSubBroker1Dropdown}
                                  isSearchable
                                  isClearable
                                  placeholder="Select"
                                  value={selectedBroker1}
                                  className="select-color"
                                  theme={the}
                                  styles={customStyles}
                                />
                              </Col>
                              <Col sm={6} className="mt-1">
                                <b className="fss-875 label-color">
                                  BROKER 1 PARTNERSHIP
                                </b>
                                <Form.Control
                                  type="number"
                                  size="sm"
                                  className="bg-white text-black value-color custom-placeholder "
                                  name="selectBroker1Partner"
                                  value={selectBroker1Partner}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                      setSelectBroker1Partner(value);
                                    }
                                  }}
                                  placeholder="Broker Partnership"
                                  inputMode="numeric"
                                />
                              </Col>
                            </Row>
                            <Row className="mt-1">
                              <Col sm={6}>
                                <b className="fss-875 label-color">BROKER 2</b>
                                <Select
                                  options={subBroker.map((item) => ({
                                    value: item.adminId,
                                    label: `${item.firstName} (${item.userName})`,
                                  }))}
                                  onChange={handleSubBroker2Dropdown}
                                  isSearchable
                                  isClearable
                                  placeholder="Select"
                                  value={selectedBroker2}
                                  className="select-color"
                                  theme={the}
                                  styles={customStyles}
                                />
                              </Col>
                              <Col sm={6} className="mt-1">
                                <b className="fss-875 label-color">
                                  BROKER 2 PARTNERSHIP
                                </b>
                                <Form.Control
                                  type="number"
                                  size="sm"
                                  className="bg-white text-black value-color custom-placeholder "
                                  name="selectBroker2Partner"
                                  value={selectBroker2Partner}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                      setSelectBroker2Partner(value);
                                    }
                                  }}
                                  placeholder="Broker Partnership"
                                  inputMode="numeric"
                                />
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </>
                )}
                <Col xs={12} xl={4} className="mt-1">
                  <Card>
                    <Card.Body className="pt-0">
                      <div>
                        <Row>
                          <lagend className="fieldset-legend-title label-color">
                            USER NOTES
                          </lagend>
                        </Row>
                        <Row className="ms-1 me-1">
                          <Form.Control
                            as="textarea"
                            type="text"
                            className="mt-2  bg-white custom-placeholder value-color"
                            placeholder="Enter Remark"
                            name="remark"
                          />
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
            <div className="text-center">
              <Button
                className="mt-3 w-25 market-access"
                size="sm"
                variant="success"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "SUBMIT"
                )}
              </Button>
            </div>
            <Row className="mt-5"></Row>
          </div>
        )}
      </Form>
    </div>
  );
}
export default NewAccount;
